import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.holopy');
import { AfterViewInit, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-holopy',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.holopy/view.scss */
/* src/app/page.holopy/view.scss: no such file or directory */`],
})
export class PageHolopyComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('previewCanvas') public previewCanvas!: ElementRef<HTMLCanvasElement>;

    public imageReady: boolean = false;
    public activeTab: string = 'composite';
    public viewTab: string = 'simulate';
    public params: any = this.defaultParams();
    public nkParams: any = this.defaultNkParams();
    public nkBatch: any = this.defaultNkBatch();
    public nkFit: any = this.defaultNkFit();
    public nkFitFiles: any[] = [];
    public nkFitFileError: string = '';
    public rbcParams: any = this.defaultRbcParams();
    public customParams: any = this.defaultCustomParams();
    public imageEdit: any = this.defaultImageEdit();
    public imageEditFileName: string = '';
    public imageEditSourceDataUrl: string = '';
    public imageEditResultDataUrl: string = '';
    public imageEditResultFilename: string = '';
    public imageEditLoading: boolean = false;
    public imageEditError: string = '';
    public imageEditElapsed: number = 0;
    public imageEditModelUsed: string = '';
    public derived: any = this.computeDerived();
    public backendLoading: boolean = false;
    public backendError: string = '';
    public backendResult: any = null;
    public backendJobId: string = '';
    public backendState: string = '';
    public backendMessage: string = '';
    public backendProgress: number = 0;
    public backendPhase: string = '';
    public backendJobModelMode: string = '';
    public backendDiagnostics: any = null;
    public backendTechnicalError: string = '';
    public analysisHistory: any[] = [];
    public selectedAnalysisId: string = '';
    public showAxisDetails: boolean = false;
    private backendPollTimer: any = null;
    private backendPollMisses: number = 0;
    private backendStartAttempts: number = 0;
    private backendStartPayload: string = '';
    private backendTheoryName: string = '';
    private compositeParamsSnapshot: any = null;

    public paramGroups: any[] = [
        {
            title: '광학/검출기 세팅',
            fields: [
                { key: 'mediumIndex', label: 'medium_index', step: 0.001 },
                { key: 'illumWavelen', label: 'illum_wavelen', step: 0.001, min: 0.2, max: 1.2, slider: true, unit: 'um' },
                { key: 'polarizationX', label: 'illum_polarization X', step: 0.1 },
                { key: 'polarizationY', label: 'illum_polarization Y', step: 0.1 },
                { key: 'detectorShape', label: 'detector shape', step: 1, min: 16, max: 512 },
                { key: 'detectorSpacing', label: 'detector spacing', step: 0.1, unit: 'um' }
            ]
        },
        {
            title: '메인 산란체',
            fields: [
                {
                    key: 'mainScattererType',
                    label: '메인 산란체 종류',
                    options: [
                        { value: 'layered_sphere', label: 'Layered sphere (core-shell NK cell)' },
                        { value: 'sphere', label: 'Sphere' }
                    ],
                    wide: true
                },
                { key: 'z', label: 'z', step: 1, unit: 'um' },
                { key: 'cx', label: 'cx', step: 0.1, unit: 'um' },
                { key: 'cy', label: 'cy', step: 0.1, unit: 'um' },
                { key: 'rCore', label: 'core 반경 r_core', step: 0.01, unit: 'um', showForMain: ['layered_sphere'] },
                { key: 'tShell', label: 'shell 두께 t_shell', step: 0.01, unit: 'um', showForMain: ['layered_sphere'] },
                { key: 'nCore', label: 'core 굴절률 n_core', step: 0.001, showForMain: ['layered_sphere'] },
                { key: 'nShell', label: 'shell 굴절률 n_shell', step: 0.001, showForMain: ['layered_sphere'] },
                { key: 'mainSphereRadius', label: 'sphere 반지름', step: 0.01, unit: 'um', showForMain: ['sphere'] },
                { key: 'mainSphereN', label: 'sphere 굴절률 n', step: 0.001, showForMain: ['sphere'] }
            ]
        },
        {
            title: '부착 산란체 파라미터',
            attachmentOnly: true,
            fields: [
                { key: 'numCapsules', label: '붙이는 수', step: 1 },
                { key: 'rShort', label: 'nanorod 단축 반경', step: 0.0001, unit: 'um', showFor: ['nanorod'] },
                { key: 'rLong', label: 'nanorod 장축 반경', step: 0.0001, unit: 'um', showFor: ['nanorod'] },
                { key: 'sphereDiameter', label: 'sphere 지름', step: 0.0001, unit: 'um', showFor: ['sphere'] },
                { key: 'cubeSize', label: 'cube 한 변 길이', step: 0.0001, unit: 'um', showFor: ['cube'] },
                { key: 'smallNReal', label: '굴절률 n', step: 0.0001 },
                { key: 'smallKExt', label: '굴절률 k', step: 0.0001 }
            ]
        },
        {
            title: 'DDA 옵션',
            ddaOnly: true,
            fields: [
                { key: 'maxDplSize', label: 'max_dpl_size', step: 0.01, unit: 'um' }
            ]
        },
        {
            title: '저장/미리보기 옵션',
            fields: [
                { key: 'scaling', label: 'scaling', step: 0.01 },
                { key: 'imageVmin', label: 'PNG vmin', step: 0.1 },
                { key: 'imageVmax', label: 'PNG vmax', step: 0.1 },
                { key: 'noise', label: 'noise', step: 0.01, min: 0, max: 0.5 },
                { key: 'randomSeed', label: '배치 패턴 번호', step: 1, attachmentOnly: true },
                { key: 'previewRodLimit', label: 'preview attachment limit', step: 1, attachmentOnly: true }
            ]
        }
    ];

    public extraVariables: any[] = [
        { text: 'preview attachment limit: 미리보기 속도를 위해 화면에서는 일부만 그립니다.', attachmentOnly: true },
        { text: '실제 HoloPy 실행: Python HoloPy calc_holo로 계산하고 PNG/XLSX 파일을 만듭니다.' },
        { text: 'PNG/Excel 저장: 실제 HoloPy 실행 결과가 있으면 그 결과를 저장하고, 없으면 빠른 미리보기 계산값을 저장합니다.' },
        { text: 'noise: 빠른 미리보기와 실제 실행 결과에 더하는 검출기 노이즈 강도입니다. 원본 Python 코드와 맞추려면 0으로 두세요.' },
        { text: '메인 산란체: Layered sphere는 core-shell NK cell이고, Sphere는 단일 굴절률 구형 산란체입니다.' },
        { text: 'R_tot, R_max, bounds: 입력값에서 자동 계산되는 파생 변수입니다.' },
        { text: '배치 패턴 번호: 같은 숫자면 부착 산란체 위치가 재현되고, 숫자를 바꾸면 배치가 바뀝니다.', attachmentOnly: true },
        { text: 'centers_rel, rot_matrices, u, phi, theta: 부착 산란체 위치/방향을 만드는 난수 배열입니다.', attachmentOnly: true },
        { text: 'DDA 선택 시 nano rod, sphere, cube 같은 임의 형상 부착 산란체를 다룰 수 있습니다.', attachmentOnly: true },
        { text: 'Mie는 구형 해석 이론이라 sphere 부착 산란체만 허용합니다.', attachmentOnly: true }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.isNkFitStandalonePage) {
            this.activeTab = 'nk_fit';
            this.viewTab = 'simulate';
            this.syncNkParams();
        }
        this.loadAnalysisHistory();
    }

    public ngAfterViewInit() {
        setTimeout(() => this.render(), 0);
    }

    public ngOnDestroy() {
        this.clearBackendPoll();
    }

    public defaultParams() {
        return {
            theory: 'DDA',
            mainScattererType: 'layered_sphere',
            attachmentEnabled: true,
            attachmentShape: 'nanorod',
            mediumIndex: 1.333,
            illumWavelen: 0.470,
            polarizationX: 1,
            polarizationY: 0,
            detectorShape: 50,
            detectorSpacing: 2.2,
            z: 800.0,
            cx: 55.0,
            cy: 55.0,
            rCore: 3.98,
            tShell: 0.8,
            nCore: 1.34,
            nShell: 1.387,
            mainSphereRadius: 4.78,
            mainSphereN: 1.37,
            numCapsules: 2000,
            rShort: 0.0125,
            rLong: 0.0685,
            sphereDiameter: 0.07,
            cubeSize: 0.05,
            smallNReal: 1.3148,
            smallKExt: 1.8534,
            scaling: 0.8,
            maxDplSize: 0.3,
            imageVmin: 0,
            imageVmax: 1.7,
            noise: 0.04,
            shadowEnabled: true,
            randomSeed: 42,
            previewRodLimit: 260
        };
    }

    public defaultNkParams() {
        return {
            shellIndexMode: 'auto',
            averageCellIndex: 1.36,
            coreDiameter: 16.0,
            cytoplasmLength: 1.0,
            coreIndex: 1.35,
            shellIndex: 1.383,
            mediumIndex: 1.333,
            illumWavelen: 0.470,
            polarizationX: 1,
            polarizationY: 0,
            detectorShape: 50,
            detectorSpacing: 2.2,
            z: 800.0,
            cx: 55.0,
            cy: 55.0,
            scaling: 0.8,
            imageVmin: 0,
            imageVmax: 1.7,
            noise: 0,
            shadowEnabled: true,
            randomSeed: 42
        };
    }

    public defaultNkBatch() {
        return {
            coreDiameterStart: 15.0,
            coreDiameterEnd: 17.0,
            coreDiameterStep: 0.1,
            cytoplasmLengthStart: 0.5,
            cytoplasmLengthEnd: 1.5,
            cytoplasmLengthStep: 0.1,
            averageIndexStart: 1.356,
            averageIndexEnd: 1.373,
            averageIndexStep: 0.001,
            maxRuns: 5000
        };
    }

    public defaultNkFit() {
        return {
            centerMode: 'image_center',
            imageMode: 'field',
            extractThreshold: 20,
            extractGrid: 4,
            extractHalfSize: 15,
            removeOverlap: false,
            maxExtractedCellsPerImage: 1200,
            cellDiameterStart: 17.0,
            cellDiameterEnd: 19.0,
            cellDiameterStep: 0.1,
            nucleusDiameterStart: 15.0,
            nucleusDiameterEnd: 17.0,
            nucleusDiameterStep: 0.1,
            diameterRatioStart: 0.86,
            diameterRatioEnd: 0.92,
            averageIndexStart: 1.356,
            averageIndexEnd: 1.373,
            averageIndexStep: 0.001,
            nucleusIndexStart: 1.340,
            nucleusIndexEnd: 1.360,
            nucleusIndexStep: 0.001,
            cytoplasmIndexStart: 1.360,
            cytoplasmIndexEnd: 1.400,
            requireLowNucleusIndex: true,
            maxRuns: 300000,
            topCount: 12
        };
    }

    public defaultRbcParams() {
        return {
            rbcDiameter: 6.0,
            rbcCenterThickness: 1.44,
            rbcMaxThickness: 2.84,
            rbcIndex: 1.4,
            rbcSweepEnabled: true,
            rbcZeta: 0.60,
            rbcZetaStart: 0.60,
            rbcZetaEnd: 0.88,
            rbcZetaStep: 0.01,
            rbcMaxRuns: 80,
            rbcEulerX: 0,
            rbcEulerY: 0,
            rbcEulerZ: 0,
            rbcZMargin: 0.2,
            rbcDplMode: 'auto',
            mediumIndex: 1.33,
            illumWavelen: 0.470,
            polarizationX: 1,
            polarizationY: 0,
            detectorShape: 50,
            detectorSpacing: 2.2,
            z: 800.0,
            cx: 55.0,
            cy: 55.0,
            scaling: 0.8,
            maxDplSize: 0.03,
            imageVmin: 0,
            imageVmax: 1.7,
            rbcNoiseOffset: 0,
            rbcNoiseSigma: 0,
            shadowEnabled: true,
            randomSeed: 42
        };
    }

    public defaultCustomParams() {
        return {
            customName: 'my_scatterer',
            theory: 'DDA',
            customScattererCode: [
                '# Define a HoloPy scatterer object named scatterer.',
                '# Shared inputs below are available through params.',
                "cx = num(params, 'cx', 55.0)",
                "cy = num(params, 'cy', 55.0)",
                "z = num(params, 'z', 800.0)",
                "radius = num(params, 'customPreviewRadius', 4.78)",
                "n_particle = num(params, 'customPreviewIndex', 1.37)",
                '',
                'def ind_body(r):',
                '    rr = r[..., 0]**2 + r[..., 1]**2 + r[..., 2]**2',
                '    return rr <= radius**2',
                '',
                'bounds = [[-radius, radius], [-radius, radius], [-radius, radius]]',
                'scatterer = Scatterer(Indicators([ind_body], bounds), n_particle, center=(cx, cy, z))'
            ].join('\n'),
            mediumIndex: 1.33,
            illumWavelen: 0.470,
            polarizationX: 1,
            polarizationY: 0,
            detectorShape: 50,
            detectorSpacing: 2.2,
            scaling: 0.8,
            maxDplSize: 0.3,
            imageVmin: 0,
            imageVmax: 1.7,
            noise: 0,
            shadowEnabled: true,
            randomSeed: 42,
            customPreviewRadius: 4.78,
            customPreviewIndex: 1.37,
            z: 800.0,
            cx: 55.0,
            cy: 55.0
        };
    }

    public defaultImageEdit() {
        return {
            prompt: '',
            model: 'gpt-image-1',
            quality: 'medium',
            size: 'auto',
            outputFormat: 'png',
            background: 'auto'
        };
    }

    public reset() {
        if (this.isNkCellMode || this.isNkFitMode) {
            this.nkParams = this.defaultNkParams();
            this.nkBatch = this.defaultNkBatch();
            this.nkFit = this.defaultNkFit();
            this.nkFitFiles = [];
            this.nkFitFileError = '';
            this.syncNkParams();
        } else if (this.isRbcMode) {
            this.rbcParams = this.defaultRbcParams();
            this.syncRbcParams();
        } else if (this.isCustomMode) {
            this.customParams = this.defaultCustomParams();
            this.syncCustomParams();
        } else {
            this.params = this.defaultParams();
        }
        this.render();
    }

    public async selectTab(tab: string) {
        if (tab === 'analysis') {
            this.viewTab = 'analysis';
            this.render(false);
            await this.hydrateSelectedAnalysisRecord('image');
            return;
        }
        if (tab === this.activeTab && !this.isAnalysisMode) return;
        this.viewTab = 'simulate';
        if (tab === 'image_transform') {
            if (this.activeTab === 'composite') {
                this.compositeParamsSnapshot = { ...this.params };
            }
            this.activeTab = tab;
            await this.service.render();
            return;
        }
        if (this.activeTab === 'composite') {
            this.compositeParamsSnapshot = { ...this.params };
        }
        this.activeTab = tab;
        if (this.isNkCellMode || this.isNkFitMode) {
            this.syncNkParams();
        } else if (this.isRbcMode) {
            this.syncRbcParams();
        } else if (this.isCustomMode) {
            this.syncCustomParams();
        } else {
            this.params = this.compositeParamsSnapshot ? { ...this.compositeParamsSnapshot } : this.defaultParams();
        }
        this.render();
    }

    public get isNkCellMode() {
        return this.activeTab === 'nk_cell';
    }

    public get isNkFitMode() {
        return this.activeTab === 'nk_fit';
    }

    public get isNkFitStandalonePage() {
        return location.pathname.indexOf('/image-analysis/nk-fit') === 0;
    }

    public get isRbcMode() {
        return this.activeTab === 'rbc';
    }

    public get isCustomMode() {
        return this.activeTab === 'custom_scatterer';
    }

    public get isImageTransformMode() {
        return this.activeTab === 'image_transform';
    }

    public get isAnalysisMode() {
        return this.viewTab === 'analysis';
    }

    public get shadowMetrics() {
        const result = this.activeAnalysisResult;
        return result && result.shadow ? result.shadow.metrics || null : null;
    }

    public get shadowMetricCards() {
        const metrics = this.shadowMetrics;
        if (!metrics) return [];
        return [
            { label: 'CMV', value: metrics.CMV },
            { label: 'PPD', value: metrics.PPD },
            { label: 'MMD', value: metrics.MMD },
            { label: 'WCM', value: metrics.WCM },
            { label: 'WSM', value: metrics.WSM },
            { label: 'CSP', value: metrics.CSP },
        ];
    }

    public get shadowStdCards() {
        const metrics = this.shadowMetrics;
        if (!metrics) return [];
        return [
            { label: 'MMD_std', value: metrics.MMD_std },
            { label: 'WCM_std', value: metrics.WCM_std },
            { label: 'WSM_std', value: metrics.WSM_std },
        ];
    }

    public get shadowAngleRows() {
        const result = this.activeAnalysisResult;
        return result && result.shadow ? (result.shadow.angleMetrics || []) : [];
    }

    public get shadowAverageProfile() {
        const result = this.activeAnalysisResult;
        const values = result && result.shadow ? (result.shadow.averageProfile || []) : [];
        return values.map((value: any) => Number(value)).filter((value: number) => Number.isFinite(value));
    }

    public get shadowAxisProfiles() {
        const result = this.activeAnalysisResult;
        return result && result.shadow ? (result.shadow.axisProfiles || []) : [];
    }

    public get shadowAverageProfileMin() {
        const values = this.shadowAverageProfile;
        return values.length ? Math.min(...values) : 0;
    }

    public get shadowAverageProfileMax() {
        const values = this.shadowAverageProfile;
        return values.length ? Math.max(...values) : 0;
    }

    public get shadowAverageProfileMean() {
        const values = this.shadowAverageProfile;
        if (!values.length) return 0;
        return values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
    }

    public get shadowAveragePolyline() {
        const values = this.shadowAverageProfile;
        if (values.length < 2) return '';
        const minValue = this.shadowAverageProfileMin;
        const maxValue = this.shadowAverageProfileMax;
        const span = Math.max(1e-9, maxValue - minValue);
        const left = 24;
        const top = 16;
        const width = 316;
        const height = 158;
        return values.map((value: number, index: number) => {
            const x = left + (index / Math.max(1, values.length - 1)) * width;
            const y = top + (1 - (value - minValue) / span) * height;
            return `${x.toFixed(2)},${y.toFixed(2)}`;
        }).join(' ');
    }

    public get graphDownloadBaseName() {
        const result = this.activeAnalysisResult || this.backendResult;
        const filename = result && result.filename ? result.filename : this.baseFilename;
        return String(filename || 'holopy_analysis').replace(/\.(png|xlsx|xls|zip|csv|svg)$/i, '');
    }

    public get shadowAggregateInfo() {
        const result = this.activeAnalysisResult;
        return result && result.shadowAggregate ? (result.shadowAggregate.CSP_information || null) : null;
    }

    public get shadowMitRows() {
        const result = this.activeAnalysisResult;
        return result && result.shadowAggregate ? (result.shadowAggregate.MIT || []) : [];
    }

    public get activeAnalysisRecord() {
        if (!this.analysisHistory.length) return null;
        return this.analysisHistory.find((item: any) => item.id === this.selectedAnalysisId) || this.analysisHistory[0];
    }

    public get activeAnalysisResult() {
        const record = this.activeAnalysisRecord;
        return record ? record.result : null;
    }

    public get activeAnalysisHasShadowExcel() {
        const result = this.activeAnalysisResult;
        return !!(result && (result.shadowXlsxDataUrl || result.shadowXlsxFilename));
    }

    public get activeAnalysisHasBatchZip() {
        const result = this.activeAnalysisResult;
        return !!(result && (result.zipDataUrl || result.zipFilename));
    }

    public get activeAnalysisHasImage() {
        const result = this.activeAnalysisResult;
        return !!(result && (result.pngDataUrl || result.pngFilename));
    }

    public get activeAnalysisHasIntensityExcel() {
        const result = this.activeAnalysisResult;
        return !!(result && (result.xlsxDataUrl || result.xlsxFilename));
    }

    public renderNk() {
        this.syncNkParams();
        this.render();
    }

    public renderRbc() {
        this.syncRbcParams();
        this.render();
    }

    public renderCustom() {
        this.syncCustomParams();
        this.render();
    }

    private syncNkParams() {
        this.params = this.nkSimulationParams();
    }

    private syncRbcParams() {
        this.params = this.rbcSimulationParams();
    }

    private syncCustomParams() {
        this.params = this.customSimulationParams();
    }

    private nkNum(key: string, fallback: number) {
        const value = Number(this.nkParams[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    private rbcNum(key: string, fallback: number) {
        const value = Number(this.rbcParams[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    private customNum(key: string, fallback: number) {
        const value = Number(this.customParams[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    public get isNkShellManual() {
        return this.nkParams.shellIndexMode === 'manual';
    }

    public get nkDerived() {
        const shellIndexMode = this.isNkShellManual ? 'manual' : 'auto';
        const inputAverageIndex = this.nkNum('averageCellIndex', 1.36);
        const coreDiameter = Math.max(0.001, this.nkNum('coreDiameter', 16.0));
        const cytoplasmLength = Math.max(0.001, this.nkNum('cytoplasmLength', 1.0));
        const coreIndex = this.nkNum('coreIndex', 1.35);
        const manualShellIndex = this.nkNum('shellIndex', 1.387);
        const coreRadius = coreDiameter / 2;
        const cellRadius = coreRadius + cytoplasmLength;
        const cellDiameter = cellRadius * 2;
        const coreVolume = (4 / 3) * Math.PI * coreRadius ** 3;
        const cellVolume = (4 / 3) * Math.PI * cellRadius ** 3;
        const shellVolume = Math.max(0.000001, cellVolume - coreVolume);
        const shellIndex = shellIndexMode === 'manual'
            ? manualShellIndex
            : (inputAverageIndex * cellVolume - coreIndex * coreVolume) / shellVolume;
        const averageIndex = shellIndexMode === 'manual'
            ? (coreIndex * coreVolume + shellIndex * shellVolume) / cellVolume
            : inputAverageIndex;

        return {
            shellIndexMode,
            averageIndex,
            coreDiameter,
            cytoplasmLength,
            coreIndex,
            shellIndex,
            coreRadius,
            cellRadius,
            cellDiameter,
            coreVolume,
            shellVolume,
            cellVolume,
            coreVolumeRatio: coreVolume / cellVolume,
            shellVolumeRatio: shellVolume / cellVolume
        };
    }

    public nkSimulationParams() {
        const derived = this.nkDerived;
        return {
            modelMode: 'nk_cell',
            theory: 'Mie',
            mainScattererType: 'layered_sphere',
            attachmentEnabled: false,
            attachmentShape: 'sphere',
            shellIndexMode: derived.shellIndexMode,
            averageCellIndex: derived.averageIndex,
            coreDiameter: derived.coreDiameter,
            cytoplasmLength: derived.cytoplasmLength,
            mediumIndex: this.nkNum('mediumIndex', 1.333),
            illumWavelen: this.nkNum('illumWavelen', 0.470),
            polarizationX: this.nkNum('polarizationX', 1),
            polarizationY: this.nkNum('polarizationY', 0),
            detectorShape: this.nkNum('detectorShape', 50),
            detectorSpacing: this.nkNum('detectorSpacing', 2.2),
            z: this.nkNum('z', 800.0),
            cx: this.nkNum('cx', 55.0),
            cy: this.nkNum('cy', 55.0),
            rCore: derived.coreRadius,
            tShell: derived.cytoplasmLength,
            nCore: derived.coreIndex,
            nShell: derived.shellIndex,
            shellIndex: derived.shellIndex,
            scaling: this.nkNum('scaling', 0.8),
            imageVmin: this.nkNum('imageVmin', 0),
            imageVmax: this.nkNum('imageVmax', 1.7),
            noise: this.nkNum('noise', 0),
            shadowEnabled: !!this.nkParams.shadowEnabled,
            randomSeed: Math.round(this.nkNum('randomSeed', 42))
        };
    }

    public get rbcDerived() {
        const diameter = Math.max(0.001, this.rbcNum('rbcDiameter', 6.0));
        const centerThickness = Math.max(0.001, this.rbcNum('rbcCenterThickness', 1.44));
        const maxThickness = Math.max(0.001, this.rbcNum('rbcMaxThickness', 2.84));
        const zetaStart = this.clamp(this.rbcNum('rbcZetaStart', 0.60), 0.001, 0.999);
        const zetaEnd = this.clamp(this.rbcNum('rbcZetaEnd', 0.88), 0.001, 0.999);
        const zetaStep = Math.max(0.0001, Math.abs(this.rbcNum('rbcZetaStep', 0.01)));
        const sweepEnabled = this.rbcParams.rbcSweepEnabled !== false;
        const zetaSingle = this.clamp(this.rbcNum('rbcZeta', zetaStart), 0.001, 0.999);
        const particleIndex = this.rbcNum('rbcIndex', 1.4);
        const mediumIndex = Math.max(0.000001, this.rbcNum('mediumIndex', 1.33));
        const illumWavelen = Math.max(0.000001, this.rbcNum('illumWavelen', 0.470));
        const mediumWavelen = illumWavelen / mediumIndex;
        const zMargin = Math.max(0, this.rbcNum('rbcZMargin', 0.2));
        const eulerX = this.rbcNum('rbcEulerX', 0);
        const eulerY = this.rbcNum('rbcEulerY', 0);
        const eulerZ = this.rbcNum('rbcEulerZ', 0);
        const zetaPreview = sweepEnabled ? zetaStart : zetaSingle;
        const x = zetaPreview ** 2;
        const s = Math.sqrt(Math.max(0, 1 - x));
        const c0 = centerThickness / diameter;
        const rhs1 = maxThickness / (diameter * Math.max(1e-9, s)) - c0;
        const rhs2 = c0;
        const delta = 2 * (x ** 2) * (1 - x);
        const c1 = Math.abs(delta) < 1e-12 ? 0 : (rhs1 * (4 * x - 5 * x * x) - x * x * rhs2) / delta;
        const c2 = Math.abs(delta) < 1e-12 ? 0 : (x * rhs2 - rhs1 * (2 - 3 * x)) / delta;
        const zBoundSize = (Math.abs(eulerX) > 1e-12 || Math.abs(eulerY) > 1e-12)
            ? diameter
            : maxThickness + 2 * zMargin;
        const smallestBoundDimension = Math.max(0.000001, Math.min(diameter, diameter, zBoundSize));
        const dplFromSize = 10 * mediumWavelen / smallestBoundDimension;
        const dplFromIndex = 10 * Math.abs(particleIndex) / mediumIndex;
        const autoDpl = Math.max(dplFromSize, dplFromIndex);
        const autoDipoleSize = mediumWavelen / autoDpl;
        const dplMode = this.rbcParams.rbcDplMode === 'manual' ? 'manual' : 'auto';
        const manualMaxDipoleSize = Math.max(0.001, this.rbcNum('maxDplSize', autoDipoleSize));
        const effectiveDipoleSize = dplMode === 'manual'
            ? Math.min(autoDipoleSize, manualMaxDipoleSize)
            : autoDipoleSize;
        const effectiveDpl = mediumWavelen / effectiveDipoleSize;
        return {
            diameter,
            radius: diameter / 2,
            centerThickness,
            maxThickness,
            zetaStart,
            zetaEnd,
            zetaStep,
            zetaSingle,
            sweepEnabled,
            zetaPreview,
            c0,
            c1,
            c2,
            particleIndex,
            mediumIndex,
            illumWavelen,
            mediumWavelen,
            zMargin,
            zBoundSize,
            smallestBoundDimension,
            dplFromSize,
            dplFromIndex,
            autoDpl,
            autoDipoleSize,
            dplMode,
            manualMaxDipoleSize,
            effectiveDpl,
            effectiveDipoleSize,
            eulerX,
            eulerY,
            eulerZ
        };
    }

    public rbcSimulationParams() {
        const derived = this.rbcDerived;
        return {
            modelMode: 'rbc_zeta_batch',
            theory: 'DDA',
            mainScattererType: 'sphere',
            attachmentEnabled: false,
            attachmentShape: 'sphere',
            rbcDiameter: derived.diameter,
            rbcCenterThickness: derived.centerThickness,
            rbcMaxThickness: derived.maxThickness,
            rbcIndex: derived.particleIndex,
            rbcSweepEnabled: derived.sweepEnabled,
            rbcZeta: derived.zetaSingle,
            rbcZetaStart: derived.zetaStart,
            rbcZetaEnd: derived.zetaEnd,
            rbcZetaStep: derived.zetaStep,
            rbcMaxRuns: Math.max(1, Math.round(this.rbcNum('rbcMaxRuns', 80))),
            rbcEulerX: derived.eulerX,
            rbcEulerY: derived.eulerY,
            rbcEulerZ: derived.eulerZ,
            rbcZMargin: Math.max(0, this.rbcNum('rbcZMargin', 0.2)),
            rbcDplMode: derived.dplMode,
            mediumIndex: derived.mediumIndex,
            illumWavelen: derived.illumWavelen,
            polarizationX: this.rbcNum('polarizationX', 1),
            polarizationY: this.rbcNum('polarizationY', 0),
            detectorShape: this.rbcNum('detectorShape', 50),
            detectorSpacing: this.rbcNum('detectorSpacing', 2.2),
            z: this.rbcNum('z', 800.0),
            cx: this.rbcNum('cx', 55.0),
            cy: this.rbcNum('cy', 55.0),
            mainSphereRadius: derived.radius,
            mainSphereN: derived.particleIndex,
            rCore: derived.radius,
            tShell: 0,
            nCore: derived.particleIndex,
            nShell: derived.particleIndex,
            scaling: this.rbcNum('scaling', 0.8),
            maxDplSize: derived.manualMaxDipoleSize,
            imageVmin: this.rbcNum('imageVmin', 0),
            imageVmax: this.rbcNum('imageVmax', 1.7),
            noise: Math.max(0, this.rbcNum('rbcNoiseSigma', 0)),
            rbcNoiseOffset: this.rbcNum('rbcNoiseOffset', 0),
            rbcNoiseSigma: Math.max(0, this.rbcNum('rbcNoiseSigma', 0)),
            shadowEnabled: !!this.rbcParams.shadowEnabled,
            randomSeed: Math.round(this.rbcNum('randomSeed', 42))
        };
    }

    public customSimulationParams() {
        const theory = this.customParams.theory === 'Mie' ? 'Mie' : 'DDA';
        const previewRadius = Math.max(0.001, this.customNum('customPreviewRadius', 4.78));
        const previewIndex = this.customNum('customPreviewIndex', 1.37);
        return {
            modelMode: 'custom_scatterer',
            theory,
            mainScattererType: 'sphere',
            attachmentEnabled: false,
            attachmentShape: 'sphere',
            customName: String(this.customParams.customName || 'my_scatterer').trim() || 'my_scatterer',
            customScattererCode: String(this.customParams.customScattererCode || ''),
            mediumIndex: this.customNum('mediumIndex', 1.33),
            illumWavelen: this.customNum('illumWavelen', 0.470),
            polarizationX: this.customNum('polarizationX', 1),
            polarizationY: this.customNum('polarizationY', 0),
            detectorShape: this.customNum('detectorShape', 50),
            detectorSpacing: this.customNum('detectorSpacing', 2.2),
            z: this.customNum('z', 800.0),
            cx: this.customNum('cx', 55.0),
            cy: this.customNum('cy', 55.0),
            mainSphereRadius: previewRadius,
            mainSphereN: previewIndex,
            rCore: previewRadius,
            tShell: 0,
            nCore: previewIndex,
            nShell: previewIndex,
            scaling: this.customNum('scaling', 0.8),
            maxDplSize: Math.max(0.001, this.customNum('maxDplSize', 0.3)),
            imageVmin: this.customNum('imageVmin', 0),
            imageVmax: this.customNum('imageVmax', 1.7),
            noise: Math.max(0, this.customNum('noise', 0)),
            shadowEnabled: !!this.customParams.shadowEnabled,
            randomSeed: Math.round(this.customNum('randomSeed', 42))
        };
    }

    public get rbcBatchCount() {
        if (!this.rbcDerived.sweepEnabled) return 1;
        return this.rangeCount(
            this.rbcDerived.zetaStart,
            this.rbcDerived.zetaEnd,
            this.rbcDerived.zetaStep,
        );
    }

    public get rbcBatchLimitExceeded() {
        if (!this.rbcDerived.sweepEnabled) return false;
        return this.rbcBatchCount > Math.max(1, Math.round(this.rbcNum('rbcMaxRuns', 80)));
    }

    private batchNum(key: string, fallback: number) {
        const value = Number(this.nkBatch[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    private rangeCount(start: number, end: number, step: number) {
        if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(step) || step <= 0) return 0;
        const low = Math.min(start, end);
        const high = Math.max(start, end);
        return Math.floor((high - low) / step + 1e-9) + 1;
    }

    public get nkBatchCount() {
        return this.rangeCount(
            this.batchNum('coreDiameterStart', 15.0),
            this.batchNum('coreDiameterEnd', 17.0),
            this.batchNum('coreDiameterStep', 0.1),
        ) * this.rangeCount(
            this.batchNum('cytoplasmLengthStart', 0.5),
            this.batchNum('cytoplasmLengthEnd', 1.5),
            this.batchNum('cytoplasmLengthStep', 0.1),
        ) * this.rangeCount(
            this.batchNum('averageIndexStart', 1.356),
            this.batchNum('averageIndexEnd', 1.373),
            this.batchNum('averageIndexStep', 0.001),
        );
    }

    public get nkBatchLimitExceeded() {
        return this.nkBatchCount > Math.max(1, Math.round(this.batchNum('maxRuns', 5000)));
    }

    public get nkBatchBaseFilename() {
        return [
            'NK_cell_batch',
            this.filenameRangePart('coreD', this.batchNum('coreDiameterStart', 15.0), this.batchNum('coreDiameterEnd', 17.0), this.batchNum('coreDiameterStep', 0.1), 'um'),
            this.filenameRangePart('cyto', this.batchNum('cytoplasmLengthStart', 0.5), this.batchNum('cytoplasmLengthEnd', 1.5), this.batchNum('cytoplasmLengthStep', 0.1), 'um'),
            this.filenameRangePart('avgN', this.batchNum('averageIndexStart', 1.356), this.batchNum('averageIndexEnd', 1.373), this.batchNum('averageIndexStep', 0.001)),
            this.filenamePart('ncore', this.nkNum('coreIndex', 1.35)),
            this.filenamePart('det', Math.round(this.clamp(this.nkNum('detectorShape', 50), 8, 512)), 0),
            this.filenamePart('spacing', this.nkNum('detectorSpacing', 2.2)) + 'um',
            this.filenamePart('scaling', this.nkNum('scaling', 0.8)),
        ].join('_');
    }

    public nkBatchSimulationParams() {
        const base = this.nkSimulationParams();
        return {
            ...base,
            modelMode: 'nk_cell_batch',
            shellIndexMode: 'auto',
            batchCoreDiameterStart: this.batchNum('coreDiameterStart', this.nkDerived.coreDiameter),
            batchCoreDiameterEnd: this.batchNum('coreDiameterEnd', this.nkDerived.coreDiameter),
            batchCoreDiameterStep: this.batchNum('coreDiameterStep', 0.1),
            batchCytoplasmLengthStart: this.batchNum('cytoplasmLengthStart', this.nkDerived.cytoplasmLength),
            batchCytoplasmLengthEnd: this.batchNum('cytoplasmLengthEnd', this.nkDerived.cytoplasmLength),
            batchCytoplasmLengthStep: this.batchNum('cytoplasmLengthStep', 0.1),
            batchAverageIndexStart: this.batchNum('averageIndexStart', this.nkNum('averageCellIndex', 1.36)),
            batchAverageIndexEnd: this.batchNum('averageIndexEnd', this.nkNum('averageCellIndex', 1.36)),
            batchAverageIndexStep: this.batchNum('averageIndexStep', 0.001),
            batchMaxRuns: Math.max(1, Math.round(this.batchNum('maxRuns', 5000)))
        };
    }

    private fitNum(key: string, fallback: number) {
        const value = Number(this.nkFit[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    private fitRangeCount(startKey: string, endKey: string, stepKey: string, fallbackStart: number, fallbackStep: number) {
        return this.rangeCount(
            this.fitNum(startKey, fallbackStart),
            this.fitNum(endKey, fallbackStart),
            Math.max(0.000001, Math.abs(this.fitNum(stepKey, fallbackStep))),
        );
    }

    private fitRangeValues(startKey: string, endKey: string, stepKey: string, fallbackStart: number, fallbackStep: number) {
        const start = this.fitNum(startKey, fallbackStart);
        const end = this.fitNum(endKey, start);
        const step = Math.max(0.000001, Math.abs(this.fitNum(stepKey, fallbackStep)));
        const low = Math.min(start, end);
        const high = Math.max(start, end);
        const values: number[] = [];
        for (let value = low, guard = 0; value <= high + step * 0.000001 && guard < 10000; value += step, guard += 1) {
            values.push(Number(value.toFixed(10)));
        }
        return values.length ? values : [low];
    }

    public get nkFitFileCount() {
        return this.nkFitFiles.length;
    }

    public get nkFitSizePairCount() {
        const cellDiameters = this.fitRangeValues('cellDiameterStart', 'cellDiameterEnd', 'cellDiameterStep', 17.0, 0.1);
        const nucleusDiameters = this.fitRangeValues('nucleusDiameterStart', 'nucleusDiameterEnd', 'nucleusDiameterStep', 15.0, 0.1);
        const ratioMin = this.fitNum('diameterRatioStart', 0.86);
        const ratioMax = this.fitNum('diameterRatioEnd', 0.92);
        let count = 0;
        for (const cellDiameter of cellDiameters) {
            for (const nucleusDiameter of nucleusDiameters) {
                const ratio = nucleusDiameter / cellDiameter;
                if (nucleusDiameter < cellDiameter && ratio >= ratioMin && ratio <= ratioMax) {
                    count += 1;
                }
            }
        }
        return count;
    }

    public get nkFitBatchCount() {
        return this.nkFitSizePairCount *
            this.fitRangeCount('averageIndexStart', 'averageIndexEnd', 'averageIndexStep', 1.356, 0.001) *
            this.fitRangeCount('nucleusIndexStart', 'nucleusIndexEnd', 'nucleusIndexStep', 1.340, 0.001);
    }

    public get nkFitLimitExceeded() {
        return this.nkFitBatchCount > Math.max(1, Math.round(this.fitNum('maxRuns', 300000)));
    }

    public get nkFitReady() {
        return this.nkFitFileCount > 0 && this.nkFitBatchCount > 0;
    }

    public get nkFitFixedSummary() {
        return [
            'LED 470 nm',
            'z 800 um',
            'detector 50 px',
            'pitch 2.2 um',
            'medium refractive index 1.333',
            'alpha 0.8',
            'Python HoloPy calc_holo per candidate',
            '12 full-line axes'
        ];
    }

    public get nkLiteratureSources() {
        return [
            {
                title: 'Mesecke et al. 2011, Science Signaling Supplementary Fig. S1',
                evidence: 'NKL cellular dimensions: cell diameter 18 um, nucleus diameter 16 um, nucleus volume 2145 um^3, cytoplasm volume 909 um^3. Fitting size sweep is centered on these values.',
                source: 'DOI 10.1126/scisignal.2001325',
                url: 'https://www.science.org/doi/10.1126/scisignal.2001325'
            },
            {
                title: 'Zhang et al. 2017, Scientific Reports',
                evidence: 'Single-cell quantitative refractive-index mapping reports nucleus/cytoplasm refractive-index ranges and uses compartment height/volume relations, so the fitting derives cytoplasm refractive index by volume weighting.',
                source: 'DOI 10.1038/s41598-017-02797-8',
                url: 'https://www.nature.com/articles/s41598-017-02797-8'
            },
            {
                title: 'Steelman et al. 2017, Journal of Biophotonics',
                evidence: 'Validated that nuclear refractive index can be lower than cytoplasm refractive index and examined Mie/angle-resolved low-coherence interferometry scattering effects. Fitting keeps nucleus refractive index <= cytoplasm refractive index by default.',
                source: 'DOI 10.1002/jbio.201600314',
                url: 'https://pubmed.ncbi.nlm.nih.gov/28418104/'
            },
            {
                title: 'Muller and Guck 2018, Journal of Biophotonics response',
                evidence: 'Supports the lower-nuclear-refractive-index interpretation across multiple cell-line phase-imaging studies and explains why profile dips can be obscured by organelles, noise, and blur.',
                source: 'DOI 10.1002/jbio.201800095',
                url: 'https://arxiv.org/abs/1805.06214'
            }
        ];
    }

    public get nkFitResult() {
        const result = this.backendResult && this.backendResult.fit
            ? this.backendResult
            : (this.activeAnalysisResult && this.activeAnalysisResult.fit ? this.activeAnalysisResult : null);
        return result ? result.fit : null;
    }

    public get nkFitBackendResult() {
        return this.backendResult && this.backendResult.modelMode === 'nk_cell_fit' && this.backendResult.fit
            ? this.backendResult
            : null;
    }

    public get nkFitActiveJob() {
        return this.backendJobModelMode === 'nk_cell_fit';
    }

    public get nkFitBest() {
        return this.nkFitResult ? this.nkFitResult.best || null : null;
    }

    public get nkFitDiagnostics() {
        return this.nkFitActiveJob ? this.backendDiagnostics : null;
    }

    public get nkFitDiagnosticHistory() {
        const history = this.nkFitDiagnostics && Array.isArray(this.nkFitDiagnostics.history)
            ? this.nkFitDiagnostics.history
            : [];
        return history.slice(-6).reverse();
    }

    public nkFitCandidateSummary(candidate: any) {
        if (!candidate) return '';
        return [
            `cellD ${this.diagnosticNumber(candidate.cell_diameter_um, 1)} um`,
            `nucleusD ${this.diagnosticNumber(candidate.nucleus_diameter_um, 1)} um`,
            `average refractive index ${this.diagnosticNumber(candidate.average_cell_index, 3)}`,
            `nucleus refractive index ${this.diagnosticNumber(candidate.nucleus_index, 3)}`,
            `cytoplasm refractive index ${this.diagnosticNumber(candidate.cytoplasm_index, 3)}`,
        ].join(' · ');
    }

    public diagnosticDuration(value: any) {
        const totalSeconds = Math.max(0, Math.round(Number(value) || 0));
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (hours > 0) return `${hours}시간 ${minutes}분`;
        if (minutes > 0) return `${minutes}분 ${seconds}초`;
        return `${seconds}초`;
    }

    public diagnosticNumber(value: any, digits: number = 3) {
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric.toFixed(digits) : '-';
    }

    public get nkFitTopRows() {
        return this.nkFitResult ? (this.nkFitResult.topCandidates || []) : [];
    }

    public get nkFitReferenceProfile() {
        const result = this.nkFitResult;
        const values = result && result.reference ? (result.reference.averageProfile || []) : [];
        return values.map((value: any) => Number(value)).filter((value: number) => Number.isFinite(value));
    }

    public get nkFitBestProfile() {
        const best = this.nkFitBest;
        const values = best ? (best.best_profile || []) : [];
        return values.map((value: any) => Number(value)).filter((value: number) => Number.isFinite(value));
    }

    public get nkFitComparisonReady() {
        return this.nkFitReferenceProfile.length > 1 && this.nkFitBestProfile.length > 1;
    }

    public get nkFitComparisonMin() {
        const values = [...this.nkFitReferenceProfile, ...this.nkFitBestProfile];
        return values.length ? Math.min(...values) : 0;
    }

    public get nkFitComparisonMax() {
        const values = [...this.nkFitReferenceProfile, ...this.nkFitBestProfile];
        return values.length ? Math.max(...values) : 1;
    }

    public get nkFitReferencePolyline() {
        return this.profilePolylineForBox(this.nkFitReferenceProfile, 24, 16, 316, 158, this.nkFitComparisonMin, this.nkFitComparisonMax);
    }

    public get nkFitBestPolyline() {
        return this.profilePolylineForBox(this.nkFitBestProfile, 24, 16, 316, 158, this.nkFitComparisonMin, this.nkFitComparisonMax);
    }

    public get nkFitReferenceSummary() {
        const result = this.nkFitResult;
        const reference = result && result.reference ? result.reference : null;
        if (!reference) return '';
        const sourceCount = reference.sourceImageCount || 0;
        const cropCount = reference.cropCount || reference.imageCount || 0;
        return `source ${sourceCount}장 · extracted cell crop ${cropCount}개 평균`;
    }

    public get nkFitStatusVisible() {
        return this.isNkFitMode && (
            (this.nkFitActiveJob && (this.backendLoading || !!this.backendError)) ||
            !!this.nkFitBackendResult ||
            this.nkFitLimitExceeded
        );
    }

    public get nkFitCandidateLimitMessage() {
        const maxRuns = Math.max(1, Math.round(this.fitNum('maxRuns', 300000)));
        if (!this.nkFitLimitExceeded) return '';
        return `프론트 예상 후보가 ${this.nkFitBatchCount}개로 max candidates ${maxRuns}개보다 큽니다. 실제 실행 시 backend가 cytoplasm refractive index 범위까지 먼저 필터링하고, 필터 후에도 max를 넘으면 중단합니다.`;
    }

    public nkFitSimulationParams() {
        return {
            modelMode: 'nk_cell_fit',
            theory: 'Mie',
            mainScattererType: 'layered_sphere',
            attachmentEnabled: false,
            fitImages: this.nkFitFiles.map((item: any) => ({
                name: item.name,
                dataUrl: item.dataUrl
            })),
            fitCenterMode: 'image_center',
            fitImageMode: this.nkFit.imageMode === 'crop' ? 'crop' : 'field',
            fitExtractThreshold: Math.max(1, Math.round(this.fitNum('extractThreshold', 20))),
            fitExtractGrid: Math.max(1, Math.round(this.fitNum('extractGrid', 4))),
            fitExtractHalfSize: Math.max(2, Math.round(this.fitNum('extractHalfSize', 15))),
            fitRemoveOverlap: !!this.nkFit.removeOverlap,
            fitMaxExtractedCellsPerImage: Math.max(1, Math.round(this.fitNum('maxExtractedCellsPerImage', 1200))),
            fitCellDiameterStart: this.fitNum('cellDiameterStart', 17.0),
            fitCellDiameterEnd: this.fitNum('cellDiameterEnd', 19.0),
            fitCellDiameterStep: Math.max(0.000001, Math.abs(this.fitNum('cellDiameterStep', 0.1))),
            fitNucleusDiameterStart: this.fitNum('nucleusDiameterStart', 15.0),
            fitNucleusDiameterEnd: this.fitNum('nucleusDiameterEnd', 17.0),
            fitNucleusDiameterStep: Math.max(0.000001, Math.abs(this.fitNum('nucleusDiameterStep', 0.1))),
            fitDiameterRatioStart: this.fitNum('diameterRatioStart', 0.86),
            fitDiameterRatioEnd: this.fitNum('diameterRatioEnd', 0.92),
            fitAverageIndexStart: this.fitNum('averageIndexStart', 1.356),
            fitAverageIndexEnd: this.fitNum('averageIndexEnd', 1.373),
            fitAverageIndexStep: Math.max(0.000001, Math.abs(this.fitNum('averageIndexStep', 0.001))),
            fitNucleusIndexStart: this.fitNum('nucleusIndexStart', 1.340),
            fitNucleusIndexEnd: this.fitNum('nucleusIndexEnd', 1.360),
            fitNucleusIndexStep: Math.max(0.000001, Math.abs(this.fitNum('nucleusIndexStep', 0.001))),
            fitCytoplasmIndexStart: this.fitNum('cytoplasmIndexStart', 1.360),
            fitCytoplasmIndexEnd: this.fitNum('cytoplasmIndexEnd', 1.400),
            fitRequireLowNucleusIndex: this.nkFit.requireLowNucleusIndex !== false,
            fitMaxRuns: Math.max(1, Math.round(this.fitNum('maxRuns', 300000))),
            fitTopCount: Math.max(1, Math.round(this.fitNum('topCount', 12))),
            mediumIndex: 1.333,
            illumWavelen: 0.470,
            detectorShape: 50,
            detectorSpacing: 2.2,
            z: 800.0,
            cx: 55.0,
            cy: 55.0,
            scaling: 0.8,
            imageVmin: this.nkNum('imageVmin', 0),
            imageVmax: this.nkNum('imageVmax', 1.7),
            noise: 0,
            shadowEnabled: true
        };
    }

    public async onNkFitFileChange(event: any) {
        const input = event && event.target ? event.target : null;
        const files = input && input.files ? Array.from(input.files) as File[] : [];
        if (!files.length) return;

        this.nkFitFileError = '';
        for (const file of files) {
            if (!/^image\/(png|jpeg|jpg|webp)$/i.test(file.type || '')) {
                this.nkFitFileError = 'PNG, JPG, WEBP 이미지만 업로드할 수 있습니다.';
                continue;
            }
            if (file.size > 30 * 1024 * 1024) {
                this.nkFitFileError = '이미지 하나는 30MB 이하만 사용할 수 있습니다.';
                continue;
            }
            if (this.nkFitFiles.length >= 30) {
                this.nkFitFileError = '한 번에 최대 30장까지 사용할 수 있습니다.';
                break;
            }
            this.nkFitFiles.push({
                id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
                name: file.name || 'nk-shadow-image',
                size: file.size,
                dataUrl: await this.readFileAsDataUrl(file)
            });
        }
        if (input) input.value = '';
        await this.service.render();
    }

    public async removeNkFitFile(id: string) {
        this.nkFitFiles = this.nkFitFiles.filter((item: any) => item.id !== id);
        await this.service.render();
    }

    public async clearNkFitFiles() {
        this.nkFitFiles = [];
        this.nkFitFileError = '';
        await this.service.render();
    }

    public async runNkFit(runLimit: number = 0) {
        if (!this.nkFitFileCount) {
            await this.showNkFitInputError('실제 NK shadow 이미지를 먼저 업로드해 주세요.');
            return;
        }
        if (this.nkFitBatchCount < 1) {
            await this.showNkFitInputError('fitting 후보 조건 수를 확인해 주세요.');
            return;
        }
        const payload = this.nkFitSimulationParams();
        payload.fitRunLimit = Math.max(0, Math.round(Number(runLimit) || 0));
        await this.launchBackendJob(payload);
    }

    private async showNkFitInputError(message: string) {
        this.clearBackendPoll();
        this.backendLoading = false;
        this.backendResult = null;
        this.backendError = message;
        this.backendJobId = '';
        this.backendState = 'input_error';
        this.backendProgress = 0;
        this.backendPhase = '입력 조건 확인';
        this.backendJobModelMode = 'nk_cell_fit';
        this.backendMessage = message;
        await this.service.render();
    }

    private applyNkFitResultToInputs(best: any, shouldRender: boolean = true) {
        if (!best) return;
        this.nkParams = {
            ...this.nkParams,
            shellIndexMode: 'manual',
            averageCellIndex: Number(best.average_cell_index || this.nkParams.averageCellIndex),
            coreDiameter: Number(best.nucleus_diameter_um || this.nkParams.coreDiameter),
            cytoplasmLength: Number(best.cytoplasm_length_um || this.nkParams.cytoplasmLength),
            coreIndex: Number(best.nucleus_index || this.nkParams.coreIndex),
            shellIndex: Number(best.cytoplasm_index || this.nkParams.shellIndex),
            mediumIndex: 1.333,
            illumWavelen: 0.470,
            detectorShape: 50,
            detectorSpacing: 2.2,
            z: 800.0,
            cx: 55.0,
            cy: 55.0,
            scaling: 0.8,
            noise: 0,
            shadowEnabled: true
        };
        this.syncNkParams();
        if (shouldRender) {
            this.render(false);
        }
    }

    public async applyNkFitBest() {
        const best = this.nkFitBest;
        this.activeTab = this.isNkFitStandalonePage ? 'nk_fit' : 'nk_cell';
        this.viewTab = 'simulate';
        this.applyNkFitResultToInputs(best, true);
        await this.service.render();
    }

    public onTheoryChange() {
        if (this.params.attachmentEnabled && this.params.theory === 'Mie') {
            this.params.attachmentShape = 'sphere';
        }
        this.render();
    }

    public onAttachmentToggle() {
        if (this.params.attachmentEnabled && this.params.theory === 'Mie') {
            this.params.attachmentShape = 'sphere';
        }
        this.render();
    }

    public onAttachmentShapeChange() {
        if (this.params.theory === 'Mie' && this.params.attachmentShape !== 'sphere') {
            this.params.attachmentShape = 'sphere';
        }
        this.render();
    }

    public showGroup(group: any) {
        if (group.ddaOnly && this.params.theory === 'Mie') return false;
        if (group.attachmentOnly && !this.params.attachmentEnabled) return false;
        return (group.fields || []).some((field: any) => this.showField(field));
    }

    public showField(field: any) {
        if (field.attachmentOnly && !this.params.attachmentEnabled) return false;
        if (field.ddaOnly && this.params.theory === 'Mie') return false;
        if (field.showForMain && !field.showForMain.includes(this.params.mainScattererType)) return false;
        if (this.params.theory === 'Mie' && field.showFor && !field.showFor.includes('sphere')) return false;
        if (field.showFor && !field.showFor.includes(this.params.attachmentShape)) return false;
        return true;
    }

    public get baseFilename() {
        if (this.isNkCellMode || this.isNkFitMode) {
            return this.nkBaseFilename;
        }
        if (this.isRbcMode) {
            return this.rbcBaseFilename;
        }
        if (this.isCustomMode) {
            return this.customBaseFilename;
        }
        const theory = this.params.theory || 'DDA';
        const mainType = this.params.mainScattererType === 'sphere' ? 'sphere' : 'layered';
        const attachmentsOn = !!this.params.attachmentEnabled;
        const attachmentShape = this.params.attachmentShape || 'nanorod';
        const nParticles = attachmentsOn ? Math.max(0, Math.round(this.num('numCapsules', 2000))) : 0;
        const hasAttachments = attachmentsOn && nParticles > 0;
        const parts: string[] = [
            'HoloPy',
            String(theory).toUpperCase(),
            mainType === 'sphere' ? 'Sphere' : 'LayeredSphere',
        ];

        if (mainType === 'sphere') {
            const radius = this.num('mainSphereRadius', 4.78);
            parts.push(
                this.filenamePart('R', radius) + 'um',
                this.filenamePart('D', 2 * radius) + 'um',
                this.filenamePart('nmain', this.num('mainSphereN', 1.37)),
            );
        } else {
            const rCore = this.num('rCore', 3.98);
            const tShell = this.num('tShell', 0.8);
            parts.push(
                this.filenamePart('coreD', 2 * rCore) + 'um',
                this.filenamePart('cyto', tShell) + 'um',
                this.filenamePart('cellD', 2 * (rCore + tShell)) + 'um',
                this.filenamePart('ncore', this.num('nCore', 1.34)),
                this.filenamePart('nshell', this.num('nShell', 1.387)),
            );
        }

        if (hasAttachments) {
            const attachmentFileLabel = attachmentShape === 'nanorod' ? 'AuNR' : (attachmentShape === 'cube' ? 'Cube' : 'Sphere');
            parts.push(
                this.filenamePart('with', attachmentFileLabel),
                this.filenamePart('N', nParticles, 0),
            );
            if (attachmentShape === 'sphere') {
                parts.push(this.filenamePart('diameter', this.num('sphereDiameter', 0.07)) + 'um');
            } else if (attachmentShape === 'cube') {
                parts.push(this.filenamePart('cubeSide', this.num('cubeSize', 0.05)) + 'um');
            } else {
                parts.push(
                    this.filenamePart('rodR', this.num('rShort', 0.0125)) + 'um',
                    this.filenamePart('rodL', this.num('rLong', 0.0685)) + 'um',
                );
            }
            parts.push(
                this.filenamePart('n', this.num('smallNReal', 1.3148)),
                this.filenamePart('k', this.num('smallKExt', 1.8534)),
            );
        } else {
            parts.push('no_attachment');
        }

        parts.push(
            this.filenamePart('lambda', this.num('illumWavelen', 0.470)) + 'um',
            this.filenamePart('medium', this.num('mediumIndex', 1.33)),
            this.filenamePart('pol', `${this.filenameValue(this.num('polarizationX', 1))}x${this.filenameValue(this.num('polarizationY', 0))}`),
            this.filenamePart('z', this.num('z', 800.0)) + 'um',
            this.filenamePart('cx', this.num('cx', 55.0)) + 'um',
            this.filenamePart('cy', this.num('cy', 55.0)) + 'um',
            this.filenamePart('det', Math.round(this.clamp(this.num('detectorShape', 50), 8, 512)), 0),
            this.filenamePart('spacing', this.num('detectorSpacing', 2.2)) + 'um',
            this.filenamePart('scaling', this.num('scaling', 0.8)),
        );

        if (theory === 'DDA') {
            parts.push(this.filenamePart('maxDpl', this.num('maxDplSize', 0.3)) + 'um');
        }

        parts.push(
            this.filenamePart('vmin', this.num('imageVmin', 0)),
            this.filenamePart('vmax', this.num('imageVmax', 1.7)),
            this.filenamePart('noise', this.num('noise', 0.04)),
        );
        if (hasAttachments || this.num('noise', 0.04) > 0) {
            parts.push(this.filenamePart('seed', Math.round(this.num('randomSeed', 42)), 0));
        }

        return parts.join('_');
    }

    public get nkBaseFilename() {
        const derived = this.nkDerived;
        const parts: string[] = [
            'NK_cell',
            this.filenamePart('avgN', derived.averageIndex),
            this.filenamePart('coreD', derived.coreDiameter) + 'um',
            this.filenamePart('cyto', derived.cytoplasmLength) + 'um',
            this.filenamePart('cellD', derived.cellDiameter) + 'um',
            this.filenamePart('ncore', derived.coreIndex),
            this.filenamePart('nshell', derived.shellIndex),
            this.filenamePart('lambda', this.nkNum('illumWavelen', 0.470)) + 'um',
            this.filenamePart('medium', this.nkNum('mediumIndex', 1.333)),
            this.filenamePart('pol', `${this.filenameValue(this.nkNum('polarizationX', 1))}x${this.filenameValue(this.nkNum('polarizationY', 0))}`),
            this.filenamePart('z', this.nkNum('z', 800.0)) + 'um',
            this.filenamePart('cx', this.nkNum('cx', 55.0)) + 'um',
            this.filenamePart('cy', this.nkNum('cy', 55.0)) + 'um',
            this.filenamePart('det', Math.round(this.clamp(this.nkNum('detectorShape', 50), 8, 512)), 0),
            this.filenamePart('spacing', this.nkNum('detectorSpacing', 2.2)) + 'um',
            this.filenamePart('scaling', this.nkNum('scaling', 0.8)),
            this.filenamePart('vmin', this.nkNum('imageVmin', 0)),
            this.filenamePart('vmax', this.nkNum('imageVmax', 1.7)),
            this.filenamePart('noise', this.nkNum('noise', 0))
        ];
        if (this.nkNum('noise', 0) > 0) {
            parts.push(this.filenamePart('seed', Math.round(this.nkNum('randomSeed', 42)), 0));
        }
        return parts.join('_');
    }

    public get rbcBaseFilename() {
        const derived = this.rbcDerived;
        const zetaPart = derived.sweepEnabled
            ? this.filenameRangePart('zeta', derived.zetaStart, derived.zetaEnd, derived.zetaStep)
            : this.filenamePart('zeta', derived.zetaSingle);
        const parts: string[] = [
            derived.sweepEnabled ? 'RBC_zeta_sweep' : 'RBC_zeta_single',
            this.filenamePart('D', derived.diameter) + 'um',
            this.filenamePart('t', derived.centerThickness) + 'um',
            this.filenamePart('h', derived.maxThickness) + 'um',
            zetaPart,
            this.filenamePart('euler', `${this.filenameValue(derived.eulerX)}x${this.filenameValue(derived.eulerY)}x${this.filenameValue(derived.eulerZ)}`),
            this.filenamePart('n', derived.particleIndex),
            this.filenamePart('lambda', this.rbcNum('illumWavelen', 0.470)) + 'um',
            this.filenamePart('medium', this.rbcNum('mediumIndex', 1.33)),
            this.filenamePart('det', Math.round(this.clamp(this.rbcNum('detectorShape', 50), 8, 512)), 0),
            this.filenamePart('spacing', this.rbcNum('detectorSpacing', 2.2)) + 'um',
            this.filenamePart('scaling', this.rbcNum('scaling', 0.8)),
            this.filenamePart('noiseOffset', this.rbcNum('rbcNoiseOffset', 0)),
            this.filenamePart('noiseSigma', this.rbcNum('rbcNoiseSigma', 0)),
        ];
        if (derived.dplMode === 'manual') {
            parts.push(this.filenamePart('maxDipole', derived.manualMaxDipoleSize) + 'um');
        } else {
            parts.push('dipole=auto');
        }
        if (this.rbcNum('rbcNoiseSigma', 0) > 0) {
            parts.push(this.filenamePart('seed', Math.round(this.rbcNum('randomSeed', 42)), 0));
        }
        return parts.join('_');
    }

    public get customBaseFilename() {
        const theory = this.customParams.theory === 'Mie' ? 'MIE' : 'DDA';
        const label = this.filenameValue(String(this.customParams.customName || 'my_scatterer'));
        const parts: string[] = [
            'CustomScatterer',
            label,
            theory,
            this.filenamePart('lambda', this.customNum('illumWavelen', 0.470)) + 'um',
            this.filenamePart('medium', this.customNum('mediumIndex', 1.33)),
            this.filenamePart('pol', `${this.filenameValue(this.customNum('polarizationX', 1))}x${this.filenameValue(this.customNum('polarizationY', 0))}`),
            this.filenamePart('det', Math.round(this.clamp(this.customNum('detectorShape', 50), 8, 512)), 0),
            this.filenamePart('spacing', this.customNum('detectorSpacing', 2.2)) + 'um',
            this.filenamePart('scaling', this.customNum('scaling', 0.8)),
            this.filenamePart('vmin', this.customNum('imageVmin', 0)),
            this.filenamePart('vmax', this.customNum('imageVmax', 1.7)),
            this.filenamePart('noise', this.customNum('noise', 0)),
        ];
        if (theory === 'DDA') {
            parts.push(this.filenamePart('maxDpl', this.customNum('maxDplSize', 0.3)) + 'um');
        }
        if (this.customNum('noise', 0) > 0) {
            parts.push(this.filenamePart('seed', Math.round(this.customNum('randomSeed', 42)), 0));
        }
        return parts.join('_');
    }

    public get mainScattererLabel() {
        if (this.isNkFitMode) return 'NK image fitting';
        if (this.isRbcMode) return 'RBC Evans-Fung';
        if (this.isCustomMode) return '사용자 산란체';
        return this.params.mainScattererType === 'sphere' ? 'Sphere' : 'Layered sphere';
    }

    public get attachmentLabel() {
        if (!this.params.attachmentEnabled) return '부착 없음';
        if (this.params.theory === 'Mie') return 'Mie sphere';
        if (this.params.attachmentShape === 'sphere') return 'sphere';
        if (this.params.attachmentShape === 'cube') return 'cube';
        return 'AuNR';
    }

    public get hasAttachments() {
        if (this.isRbcMode) return false;
        if (this.isCustomMode) return false;
        return !!this.params.attachmentEnabled && Math.max(0, Math.round(this.num('numCapsules', 2000))) > 0;
    }

    public get attachmentSummary() {
        if (!this.hasAttachments) return '';
        return `${this.attachmentLabel} ${this.num('numCapsules', 2000)}`;
    }

    public get visibleExtraVariables() {
        if (this.isNkCellMode || this.isNkFitMode) {
            const derived = this.nkDerived;
            return [
                'NKL 문헌 중심값: dcell 18 um, dnuc 16 um, Vnuc 2145 um^3, Vcyt 909 um^3',
                `세포 평균 굴절률 n_avg = ${this.formatNumber(derived.averageIndex, 4)}`,
                `세포핵 반경 r_core = coreD / 2 = ${this.formatNumber(derived.coreRadius, 4)} um`,
                `전체 세포 지름 cellD = ${this.formatNumber(derived.cellDiameter, 4)} um`,
                `세포질 굴절률 n_shell = ${this.formatNumber(derived.shellIndex, 6)}`,
                `핵 부피 비율 = ${this.formatNumber(derived.coreVolumeRatio * 100, 2)}%`,
                `세포질 부피 비율 = ${this.formatNumber(derived.shellVolumeRatio * 100, 2)}%`,
                '부피가중식: n_avg = n_core * V_core/V_cell + n_shell * V_shell/V_cell',
                'fitting 고정값: LED 470 nm, z 800 um, detector 50 px, pitch 2.2 um, medium 1.333, alpha 0.8',
                '이미지 비교: HoloPy 50x50 detector image를 후보마다 1개씩 만들고, 세포 중심을 지나는 12개 full-line gray profile 평균 graph의 Pearson correlation',
                '실제 실행은 HoloPy LayeredSphere와 Mie 이론으로 계산합니다.'
            ];
        }
        if (this.isRbcMode) {
            const derived = this.rbcDerived;
            const zetaLabel = derived.sweepEnabled
                ? `zeta sweep = ${this.formatNumber(derived.zetaStart, 4)} to ${this.formatNumber(derived.zetaEnd, 4)} step ${this.formatNumber(derived.zetaStep, 4)}`
                : `single zeta = ${this.formatNumber(derived.zetaSingle, 4)}`;
            return [
                `RBC radius = D / 2 = ${this.formatNumber(derived.radius, 4)} um`,
                zetaLabel,
                `estimated run count = ${this.rbcBatchCount}`,
                `Evans-Fung c0 = ${this.formatNumber(derived.c0, 6)}`,
                `Evans-Fung c1 = ${this.formatNumber(derived.c1, 6)}`,
                `Evans-Fung c2 = ${this.formatNumber(derived.c2, 6)}`,
                `ADDA auto dpl = ${this.formatNumber(derived.autoDpl, 6)}`,
                `ADDA auto dipole size = ${this.formatNumber(derived.autoDipoleSize, 6)} um`,
                `ADDA effective dipole size = ${this.formatNumber(derived.effectiveDipoleSize, 6)} um`,
                `Euler XYZ = (${this.formatNumber(derived.eulerX, 2)}, ${this.formatNumber(derived.eulerY, 2)}, ${this.formatNumber(derived.eulerZ, 2)}) deg`,
                'Actual execution uses HoloPy Indicators + Scatterer with DDA.'
            ];
        }
        if (this.isCustomMode) {
            const code = String(this.customParams.customScattererCode || '');
            return [
                `사용자 산란체 모델 이름 = ${String(this.customParams.customName || 'my_scatterer')}`,
                `theory = ${this.customParams.theory === 'Mie' ? 'Mie' : 'DDA'}`,
                `code length = ${code.length} chars`,
                `detector = ${Math.round(this.clamp(this.customNum('detectorShape', 50), 8, 512))} x ${Math.round(this.clamp(this.customNum('detectorShape', 50), 8, 512))}`,
                `spacing = ${this.formatNumber(this.customNum('detectorSpacing', 2.2), 4)} um`,
                "backend expects a variable named scatterer"
            ];
        }
        return this.extraVariables
            .filter((item: any) => !item.attachmentOnly || this.hasAttachments)
            .map((item: any) => item.text || item);
    }

    public computeDerived() {
        if (this.isCustomMode) {
            const detectorShape = this.customNum('detectorShape', 50);
            const detectorSpacing = this.customNum('detectorSpacing', 2.2);
            const previewRadius = Math.max(0.001, this.customNum('customPreviewRadius', 4.78));
            return {
                RTot: previewRadius,
                RPlacement: previewRadius,
                RMax: previewRadius,
                numSmall: 0,
                detectorCenter: detectorShape * detectorSpacing / 2
            };
        }
        if (this.isRbcMode) {
            const derived = this.rbcDerived;
            const detectorShape = this.rbcNum('detectorShape', 50);
            const detectorSpacing = this.rbcNum('detectorSpacing', 2.2);
            return {
                RTot: derived.radius,
                RPlacement: derived.radius,
                RMax: derived.radius,
                numSmall: 0,
                detectorCenter: detectorShape * detectorSpacing / 2
            };
        }
        const rTot = this.mainRadius();
        const detectorShape = this.num('detectorShape', 50);
        const detectorSpacing = this.num('detectorSpacing', 2.2);
        const attachRadius = this.attachmentPlacementRadius();
        const maxAttachExtent = this.attachmentMaxExtent();
        const attachmentsOn = !!this.params.attachmentEnabled;

        return {
            RTot: rTot,
            RPlacement: rTot + attachRadius,
            RMax: rTot + maxAttachExtent,
            numSmall: attachmentsOn ? this.num('numCapsules', 2000) : 0,
            detectorCenter: detectorShape * detectorSpacing / 2
        };
    }

    public attachmentPlacementRadius() {
        if (!this.params.attachmentEnabled) return 0;
        if (this.params.attachmentShape === 'sphere') return this.num('sphereDiameter', 0.07) / 2;
        if (this.params.attachmentShape === 'cube') return this.num('cubeSize', 0.05) / 2;
        return this.num('rShort', 0.0125);
    }

    public attachmentMaxExtent() {
        if (!this.params.attachmentEnabled) return 0;
        if (this.params.attachmentShape === 'sphere') return this.num('sphereDiameter', 0.07);
        if (this.params.attachmentShape === 'cube') return this.num('cubeSize', 0.05);
        return this.num('rLong', 0.0685) * 2;
    }

    public mainRadius() {
        if (this.params.mainScattererType === 'sphere') {
            return this.num('mainSphereRadius', 4.78);
        }
        return this.num('rCore', 3.98) + this.num('tShell', 0.8);
    }

    public render(clearBackend: boolean = true) {
        if (!this.previewCanvas) return;
        if (this.isNkCellMode || this.isNkFitMode) {
            this.syncNkParams();
        } else if (this.isRbcMode) {
            this.syncRbcParams();
        } else if (this.isCustomMode) {
            this.syncCustomParams();
        }

        if (clearBackend && !this.backendLoading) {
            this.backendResult = null;
            this.backendError = '';
            this.backendJobId = '';
            this.backendState = '';
            this.backendMessage = '';
            this.backendProgress = 0;
            this.backendPhase = '';
            this.backendDiagnostics = null;
            this.backendTechnicalError = '';
        }
        this.derived = this.computeDerived();
        this.drawToCanvas(this.previewCanvas.nativeElement, false);
        this.imageReady = true;
    }

    public async runHolopy() {
        const payload = this.isNkCellMode
            ? this.nkSimulationParams()
            : (this.isRbcMode ? this.rbcSimulationParams() : (this.isCustomMode ? this.customSimulationParams() : this.params));
        if (this.isRbcMode && (this.rbcBatchCount < 1 || this.rbcBatchLimitExceeded)) {
            alert('RBC zeta sweep 조건 수를 확인해 주세요.');
            return;
        }
        if (this.isCustomMode && !String(this.customParams.customScattererCode || '').trim()) {
            alert('Custom scatterer 코드를 입력해 주세요.');
            return;
        }
        await this.launchBackendJob(payload);
    }

    public async runNkBatch() {
        if (this.nkBatchCount < 1) {
            alert('반복 실험 조건 수를 확인해 주세요.');
            return;
        }
        if (this.nkBatchLimitExceeded) {
            alert(`반복 실험 조건이 ${this.nkBatchCount}개입니다. 최대 ${Math.round(this.batchNum('maxRuns', 80))}개까지 실행할 수 있습니다.`);
            return;
        }
        await this.launchBackendJob(this.nkBatchSimulationParams());
    }

    public async onImageEditFileChange(event: any) {
        const input = event && event.target ? event.target : null;
        const file = input && input.files && input.files.length ? input.files[0] : null;
        if (!file) return;

        if (!/^image\/(png|jpeg|jpg|webp)$/i.test(file.type || '')) {
            this.imageEditError = 'PNG, JPG, WEBP 이미지만 업로드할 수 있습니다.';
            this.imageEditSourceDataUrl = '';
            this.imageEditFileName = '';
            await this.service.render();
            return;
        }

        if (file.size > 50 * 1024 * 1024) {
            this.imageEditError = '이미지 파일은 50MB 이하만 사용할 수 있습니다.';
            this.imageEditSourceDataUrl = '';
            this.imageEditFileName = '';
            await this.service.render();
            return;
        }

        this.imageEditFileName = file.name || 'uploaded-image';
        this.imageEditSourceDataUrl = await this.readFileAsDataUrl(file);
        this.imageEditResultDataUrl = '';
        this.imageEditResultFilename = '';
        this.imageEditError = '';
        this.imageEditElapsed = 0;
        this.imageEditModelUsed = '';
        await this.service.render();
    }

    public async runImageEdit() {
        if (!this.imageEditSourceDataUrl) {
            alert('먼저 이미지를 업로드해 주세요.');
            return;
        }
        const prompt = String(this.imageEdit.prompt || '').trim();
        if (!prompt) {
            alert('변경할 내용을 입력해 주세요.');
            return;
        }

        this.imageEditLoading = true;
        this.imageEditError = '';
        this.imageEditResultDataUrl = '';
        this.imageEditResultFilename = '';
        this.imageEditElapsed = 0;
        this.imageEditModelUsed = '';
        await this.service.render();

        const payload = {
            ...this.imageEdit,
            prompt,
            imageDataUrl: this.imageEditSourceDataUrl,
            sourceFilename: this.imageEditFileName
        };

        try {
            const response = await wiz.call('edit_image', { payload: JSON.stringify(payload) });
            const data = response.data || {};
            if (response.code !== 200) {
                throw new Error(data.message || '이미지 변형에 실패했습니다.');
            }
            this.imageEditResultDataUrl = data.imageDataUrl || '';
            this.imageEditResultFilename = data.filename || 'edited_image.png';
            this.imageEditElapsed = Number(data.elapsed || 0);
            this.imageEditModelUsed = data.model || this.imageEdit.model || '';
            if (!this.imageEditResultDataUrl) {
                throw new Error('변형 결과 이미지가 비어 있습니다.');
            }
        } catch (error: any) {
            this.imageEditError = error && error.message ? error.message : '이미지 변형 중 오류가 발생했습니다.';
        } finally {
            this.imageEditLoading = false;
            await this.service.render();
        }
    }

    public async resetImageEdit() {
        this.imageEdit = this.defaultImageEdit();
        this.imageEditFileName = '';
        this.imageEditSourceDataUrl = '';
        this.imageEditResultDataUrl = '';
        this.imageEditResultFilename = '';
        this.imageEditLoading = false;
        this.imageEditError = '';
        this.imageEditElapsed = 0;
        this.imageEditModelUsed = '';
        await this.service.render();
    }

    public downloadImageEditResult() {
        if (!this.imageEditResultDataUrl) return;
        this.downloadDataUrl(this.imageEditResultDataUrl, this.imageEditResultFilename || 'edited_image.png');
    }

    private readFileAsDataUrl(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('이미지를 읽지 못했습니다.'));
            reader.readAsDataURL(file);
        });
    }

    private async launchBackendJob(payload: any) {
        this.clearBackendPoll();
        this.backendLoading = true;
        this.backendError = '';
        this.backendResult = null;
        this.backendJobId = '';
        this.backendState = 'queued';
        this.backendProgress = 0;
        this.backendPhase = '작업 등록 중';
        this.backendJobModelMode = payload.modelMode || '';
        this.backendDiagnostics = null;
        this.backendTechnicalError = '';
        this.backendPollMisses = 0;
        this.backendStartAttempts = 0;
        this.backendStartPayload = JSON.stringify(payload);
        this.backendTheoryName = payload.modelMode === 'nk_cell_fit'
            ? 'NK image fitting'
            : (payload.modelMode === 'nk_cell_batch'
            ? 'Mie 반복 실험'
            : (payload.modelMode === 'custom_scatterer' ? `Custom ${payload.theory || 'DDA'}` : (payload.theory || 'DDA')));
        this.backendMessage = `HoloPy ${this.backendTheoryName} 계산 작업을 서버에 등록하는 중입니다.`;
        await this.service.render();

        await this.startBackendJob();
    }

    private async startBackendJob() {
        if (!this.backendLoading || this.backendJobId) return;
        this.backendStartAttempts += 1;
        this.backendState = 'starting';
        this.backendProgress = Math.max(this.backendProgress, Math.min(18, 4 + this.backendStartAttempts * 4));
        this.backendPhase = '작업 등록 중';
        this.backendMessage = `HoloPy ${this.backendTheoryName || this.params.theory} 계산 작업을 서버에 등록하는 중입니다. (${this.backendStartAttempts}/3)`;
        await this.service.render();

        try {
            const response = await wiz.call('start_job', { payload: this.backendStartPayload || JSON.stringify(this.params) });
            const code = response.code;
            const data = response.data || {};

            if (code === 200 && data.jobId) {
                this.backendJobId = data.jobId || '';
                this.backendState = data.state || 'running';
                this.backendProgress = this.progressValue(data.progress, 1);
                this.backendPhase = this.phaseLabel(this.backendState);
                this.backendMessage = data.message || 'HoloPy 계산을 시작했습니다.';
                this.scheduleBackendPoll(1200);
            } else {
                this.handleStartJobRetry(data.message || 'HoloPy 작업 ID를 받지 못했습니다.');
            }
        } catch (error: any) {
            this.handleStartJobRetry(error && error.message ? error.message : 'HoloPy 계산 요청을 다시 확인하는 중입니다.');
        } finally {
            await this.service.render();
        }
    }

    private handleStartJobRetry(message: string) {
        this.backendState = 'starting';
        this.backendProgress = Math.max(this.backendProgress, Math.min(25, 8 + this.backendStartAttempts * 5));
        this.backendPhase = '작업 등록 재시도';
        this.backendMessage = message;
        if (this.backendStartAttempts < 3) {
            this.scheduleBackendStartRetry(1800);
            return;
        }
        this.backendLoading = false;
        this.backendError = `HoloPy 작업 등록이 실패했습니다.\n${message}`;
    }

    public async refreshHolopyStatus() {
        if (!this.backendJobId) {
            this.backendState = 'starting';
            this.backendProgress = Math.max(this.backendProgress, 5);
            this.backendPhase = '작업 등록 중';
            this.backendMessage = 'HoloPy 작업 ID가 아직 없어 작업 등록을 다시 시도합니다.';
            if (this.backendStartAttempts < 3) {
                this.scheduleBackendStartRetry(800);
            } else {
                this.backendLoading = false;
                this.backendError = 'HoloPy 작업 ID를 받지 못했습니다. 작업 등록 API 응답을 확인해야 합니다.';
            }
            await this.service.render();
            return;
        }

        try {
            const response = await wiz.call('job_status', { jobId: this.backendJobId });
            const data = response.data || {};
            if (response.code !== 200) {
                this.backendPollMisses += 1;
                this.backendState = 'checking';
                this.backendProgress = Math.max(this.backendProgress, 8);
                this.backendPhase = '상태 확인 중';
                this.backendMessage = data.message || 'HoloPy 작업 상태를 다시 확인하는 중입니다.';
                this.scheduleBackendPoll(2500);
                await this.service.render();
                return;
            }

            this.backendPollMisses = 0;
            this.backendState = data.state || 'running';
            this.backendProgress = this.progressValue(data.progress, this.backendProgress);
            this.backendPhase = this.phaseLabel(this.backendState);
            this.backendMessage = data.message || 'HoloPy 계산이 진행 중입니다.';
            if (data.diagnostics) this.backendDiagnostics = data.diagnostics;
            this.backendTechnicalError = data.technicalError || data.stderr || this.backendTechnicalError;

            if (this.backendState === 'completed') {
                if (this.nkFitActiveJob && (!data.fit || data.modelMode !== 'nk_cell_fit')) {
                    this.backendResult = null;
                    this.backendLoading = false;
                    this.backendError = 'NK image fitting 결과가 아니라 일반 HoloPy 결과가 반환되었습니다. 페이지를 새로고침한 뒤 다시 실행해 주세요.';
                    await this.service.render();
                    return;
                }
                this.backendResult = data;
                this.saveAnalysisResult(data);
                if (data.modelMode === 'nk_cell_fit' && data.fit && data.fit.best) {
                    this.applyNkFitResultToInputs(data.fit.best, false);
                }
                this.backendError = '';
                this.backendLoading = false;
                this.backendProgress = 100;
                if (data.pngDataUrl) {
                    await this.drawDataUrlToCanvas(data.pngDataUrl);
                }
            } else if (this.backendState === 'failed' || this.backendState === 'cancelled') {
                if (this.backendState === 'cancelled') {
                    this.backendResult = null;
                    this.backendError = this.backendMessage;
                    this.backendLoading = false;
                } else {
                    this.backendPollMisses += 1;
                    if (this.backendPollMisses < 3) {
                        this.backendState = 'checking';
                        this.backendProgress = Math.max(this.backendProgress, 95);
                        this.backendPhase = '결과 확인 중';
                        this.backendMessage = '결과 파일을 확인하는 중입니다.';
                        this.scheduleBackendPoll(3000);
                    } else {
                        this.backendResult = null;
                        this.backendLoading = false;
                        this.backendError = this.backendMessage || 'HoloPy 계산이 실패했습니다.';
                    }
                }
            } else {
                this.scheduleBackendPoll(2500);
            }
        } catch (error: any) {
            this.backendPollMisses += 1;
            this.backendState = 'checking';
            this.backendProgress = Math.max(this.backendProgress, 8);
            this.backendPhase = '상태 확인 중';
            this.backendMessage = error && error.message ? error.message : 'HoloPy 작업 상태를 다시 확인하는 중입니다.';
            this.scheduleBackendPoll(2500);
        }

        await this.service.render();
    }

    public async cancelHolopy() {
        if (!this.backendJobId) return;
        this.clearBackendPoll();
        const jobId = this.backendJobId;
        this.backendMessage = 'HoloPy 계산을 중단하는 중입니다.';
        await this.service.render();

        try {
            const response = await wiz.call('cancel_job', { jobId });
            const data = response.data || {};
            this.backendState = data.state || 'cancelled';
            this.backendProgress = this.progressValue(data.progress, this.backendProgress);
            this.backendPhase = this.phaseLabel(this.backendState);
            this.backendMessage = data.message || '계산을 중단했습니다.';
            if (data.diagnostics) this.backendDiagnostics = data.diagnostics;
            this.backendTechnicalError = data.technicalError || data.stderr || this.backendTechnicalError;
            this.backendError = this.backendMessage;
        } catch (error: any) {
            this.backendError = error && error.message ? error.message : '계산 중단 요청에 실패했습니다.';
        }

        this.backendLoading = false;
        await this.service.render();
    }

    private analysisStorageKey() {
        return 'holopy.analysisHistory.v1';
    }

    private analysisRecordTitle(result: any) {
        if (!result) return '분석 결과';
        if (result.modelMode === 'nk_cell_fit' && result.fit && result.fit.best) {
            const best = result.fit.best;
            const corr = Number(best.correlation_index || 0);
            return `NK fitting r=${corr.toFixed(4)} · cellD ${best.cell_diameter_um} um`;
        }
        if (result.batchCount) return `반복 ${result.batchCount}개 · ${result.filename || result.zipFilename || 'batch'}`;
        return result.filename || result.pngFilename || 'HoloPy 결과';
    }

    private compactAnalysisResult(result: any, keepDownloads: boolean = false) {
        const copy = { ...(result || {}) };
        if (!keepDownloads) {
            delete copy.pngDataUrl;
            delete copy.xlsxDataUrl;
            delete copy.zipDataUrl;
            delete copy.shadowXlsxDataUrl;
        }
        return copy;
    }

    private saveAnalysisResult(result: any) {
        if (!result || (!result.shadow && !result.shadowAggregate)) return;
        const id = result.jobId || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const record = {
            id,
            createdAt: Date.now(),
            title: this.analysisRecordTitle(result),
            modelMode: result.modelMode || 'composite',
            theory: result.theory || '',
            batchCount: result.batchCount || 0,
            result: this.compactAnalysisResult(result, true)
        };
        this.analysisHistory = [record, ...this.analysisHistory.filter((item: any) => item.id !== id)].slice(0, 30);
        this.selectedAnalysisId = id;
        this.persistAnalysisHistory();
    }

    private persistAnalysisHistory() {
        try {
            const records = this.analysisHistory.map((item: any) => ({
                ...item,
                result: this.compactAnalysisResult(item.result, false)
            }));
            window.localStorage.setItem(this.analysisStorageKey(), JSON.stringify(records.slice(0, 30)));
        } catch (error) {
            // Browsers can reject localStorage when data is too large; the in-memory list still works.
        }
    }

    private loadAnalysisHistory() {
        try {
            const raw = window.localStorage.getItem(this.analysisStorageKey());
            const records = raw ? JSON.parse(raw) : [];
            this.analysisHistory = Array.isArray(records) ? records : [];
            this.selectedAnalysisId = this.analysisHistory.length ? this.analysisHistory[0].id : '';
        } catch (error) {
            this.analysisHistory = [];
            this.selectedAnalysisId = '';
        }
    }

    public async selectAnalysisRecord(id: string) {
        this.selectedAnalysisId = id;
        this.showAxisDetails = false;
        await this.service.render();
        await this.hydrateSelectedAnalysisRecord('image');
    }

    public async toggleAxisDetails() {
        this.showAxisDetails = !this.showAxisDetails;
        await this.service.render();
    }

    public async deleteAnalysisRecord(id: string) {
        const index = this.analysisHistory.findIndex((item: any) => item.id === id);
        if (index < 0) return;
        const wasSelected = this.selectedAnalysisId === id || (this.activeAnalysisRecord && this.activeAnalysisRecord.id === id);
        this.analysisHistory = this.analysisHistory.filter((item: any) => item.id !== id);
        if (wasSelected) {
            const next = this.analysisHistory[Math.min(index, this.analysisHistory.length - 1)];
            this.selectedAnalysisId = next ? next.id : '';
        }
        this.persistAnalysisHistory();
        await this.service.render();
    }

    public async clearAnalysisHistory() {
        this.analysisHistory = [];
        this.selectedAnalysisId = '';
        try {
            window.localStorage.removeItem(this.analysisStorageKey());
        } catch (error) {
            // Ignore storage errors; the visible history is already cleared.
        }
        await this.service.render();
    }

    private async hydrateAnalysisRecord(record: any, downloadKind: 'zip' | 'shadow' | 'xlsx' | 'image' | 'any' = 'any') {
        if (!record || !record.result || !record.result.jobId) return record ? record.result : null;
        const result = record.result;
        if (downloadKind === 'zip' && (!result.zipFilename || result.zipDataUrl)) return result;
        if (downloadKind === 'shadow' && (!result.shadowXlsxFilename || result.shadowXlsxDataUrl)) return result;
        if (downloadKind === 'xlsx' && (!result.xlsxFilename || result.xlsxDataUrl)) return result;
        if (downloadKind === 'image' && (!result.pngFilename || result.pngDataUrl)) return result;
        if (downloadKind === 'any' && (result.pngDataUrl || result.xlsxDataUrl || result.zipDataUrl || result.shadowXlsxDataUrl)) return result;

        try {
            const response = await wiz.call('job_status', { jobId: result.jobId });
            const data = response.data || {};
            if (response.code === 200 && data.state === 'completed') {
                const merged = {
                    ...result,
                    ...this.compactAnalysisResult(data, true),
                };
                record.result = merged;
                record.title = this.analysisRecordTitle(merged);
                record.theory = merged.theory || record.theory || '';
                record.batchCount = merged.batchCount || record.batchCount || 0;
                this.persistAnalysisHistory();
                await this.service.render();
                return merged;
            }
        } catch (error) {
            // Keep the saved analysis visible even when old job files cannot be reloaded.
        }
        return result;
    }

    private async hydrateSelectedAnalysisRecord(downloadKind: 'zip' | 'shadow' | 'xlsx' | 'image' | 'any' = 'any') {
        const record = this.activeAnalysisRecord;
        return await this.hydrateAnalysisRecord(record, downloadKind);
    }

    public drawToCanvas(canvas: HTMLCanvasElement, fullCount: boolean) {
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const shape = Math.round(this.clamp(this.num('detectorShape', 50), 16, 512));
        if (canvas.width !== shape) canvas.width = shape;
        if (canvas.height !== shape) canvas.height = shape;

        const image = ctx.createImageData(shape, shape);
        const data = image.data;
        const values = this.makeHologram(shape, fullCount);
        const vmin = this.num('imageVmin', 0);
        const vmax = Math.max(vmin + 0.001, this.num('imageVmax', 1.7));

        for (let i = 0; i < values.length; i++) {
            const normalized = this.clamp((values[i] - vmin) / (vmax - vmin), 0, 1);
            const value = Math.round(normalized * 255);
            const index = i * 4;
            data[index] = value;
            data[index + 1] = value;
            data[index + 2] = value;
            data[index + 3] = 255;
        }

        ctx.imageSmoothingEnabled = false;
        ctx.putImageData(image, 0, 0);
    }

    public makeHologram(shape: number, fullCount: boolean = false) {
        const values = new Float32Array(shape * shape);
        const spacing = this.num('detectorSpacing', 2.2);
        const cx = this.num('cx', 55);
        const cy = this.num('cy', 55);
        const z = this.num('z', 800);
        const mediumIndex = this.num('mediumIndex', 1.33);
        const wavelength = this.num('illumWavelen', 0.470) / mediumIndex;
        const k = (2 * Math.PI) / Math.max(0.001, wavelength);
        const isMainSphere = this.params.mainScattererType === 'sphere';
        const rCore = isMainSphere ? this.num('mainSphereRadius', 4.78) : this.num('rCore', 3.98);
        const tShell = isMainSphere ? 0 : this.num('tShell', 0.8);
        const rTot = isMainSphere ? rCore : rCore + tShell;
        const nCore = isMainSphere ? this.num('mainSphereN', 1.37) : this.num('nCore', 1.34);
        const nShell = isMainSphere ? nCore : this.num('nShell', 1.387);
        const scaling = this.num('scaling', 0.8);
        const noise = this.clamp(this.num('noise', 0.04), 0, 0.5);
        const seed = Math.round(this.num('randomSeed', 42));
        const pol = Math.sqrt(this.num('polarizationX', 1) ** 2 + this.num('polarizationY', 0) ** 2) || 1;

        const attachments = this.usesAttachmentScatterers() ? this.buildAttachments(fullCount) : [];

        for (let y = 0; y < shape; y++) {
            for (let x = 0; x < shape; x++) {
                const wx = (x + 0.5) * spacing;
                const wy = (y + 0.5) * spacing;
                const dx = wx - cx;
                const dy = wy - cy;
                const radial = Math.sqrt(dx * dx + dy * dy);
                const opticalPath = Math.sqrt(radial * radial + z * z);
                const shellEnvelope = Math.exp(-(radial * radial) / (2 * (rTot * 7.0) ** 2));
                const coreEnvelope = Math.exp(-(radial * radial) / (2 * (rCore * 5.8) ** 2));
                const phase = k * opticalPath + (nCore - mediumIndex) * rCore * 5.0 + (nShell - mediumIndex) * tShell * 8.0;
                let intensity = 1.0 + Math.cos(phase) * shellEnvelope * scaling * 0.42 - coreEnvelope * 0.18;

                if (this.params.theory === 'Mie') {
                    const mieRing = Math.sin(radial * 0.95 + k * rTot * 4.0) * Math.exp(-radial / Math.max(8, rTot * 12));
                    intensity += mieRing * 0.18 * scaling * pol;
                    intensity += this.attachmentContribution(wx, wy, attachments) * scaling * pol * 0.75;
                } else {
                    intensity += this.attachmentContribution(wx, wy, attachments) * scaling * pol;
                }

                if (noise > 0) {
                    intensity += (this.random(seed, y * shape + x, 11) - 0.5) * noise * 0.8;
                    intensity += Math.sin(x * 0.43 + y * 0.31 + seed * 0.07) * noise * 0.08;
                }

                values[y * shape + x] = this.clamp(intensity, 0, 2.5);
            }
        }

        return values;
    }

    public buildAttachments(fullCount: boolean = false) {
        const attachments: any[] = [];
        const total = Math.max(0, Math.round(this.num('numCapsules', 2000)));
        const previewLimit = Math.max(0, Math.round(this.num('previewRodLimit', 260)));
        const count = fullCount ? total : Math.min(total, previewLimit);
        const rTot = this.derived.RTot;
        const rPlacement = this.derived.RPlacement;
        const seed = Math.round(this.num('randomSeed', 42));
        const cx = this.num('cx', 55);
        const cy = this.num('cy', 55);

        for (let i = 0; i < count; i++) {
            const u = this.random(seed, i, 1) * 2 - 1;
            const theta = this.random(seed, i, 2) * Math.PI * 2;
            const phi = Math.acos(u);
            const surfaceX = rPlacement * Math.sin(phi) * Math.cos(theta);
            const surfaceY = rPlacement * Math.sin(phi) * Math.sin(theta);
            const projectedScale = 5.2 + Math.abs(u) * 2.8;
            attachments.push({
                x: cx + surfaceX * projectedScale,
                y: cy + surfaceY * projectedScale,
                angle: theta + Math.PI / 2,
                shape: this.params.attachmentShape,
                weight: 0.35 + Math.abs(u) * 0.65,
                visible: Math.exp(-Math.max(0, Math.abs(u) - 0.15) * rTot * 0.08)
            });
        }

        return attachments;
    }

    public usesAttachmentScatterers() {
        if (!this.params.attachmentEnabled) return false;
        return this.params.theory === 'DDA' || (this.params.theory === 'Mie' && this.params.attachmentShape === 'sphere');
    }

    public attachmentContribution(x: number, y: number, attachments: any[]) {
        const rShort = this.num('rShort', 0.0125);
        const rLong = this.num('rLong', 0.0685);
        const sphereRadius = this.num('sphereDiameter', 0.07) / 2;
        const cubeSize = this.num('cubeSize', 0.05);
        const smallN = this.num('smallNReal', 1.3148);
        const smallK = this.num('smallKExt', 1.8534);
        const maxDpl = Math.max(0.02, this.num('maxDplSize', 0.3));
        const shortPx = Math.max(1.0, rShort * 220 / maxDpl);
        const longPx = Math.max(shortPx + 0.5, rLong * 170 / maxDpl);
        const spherePx = Math.max(1.0, sphereRadius * 180 / maxDpl);
        const cubePx = Math.max(1.0, cubeSize * 150 / maxDpl);
        let value = 0;

        for (let i = 0; i < attachments.length; i++) {
            const item = attachments[i];
            const dx = x - item.x;
            const dy = y - item.y;
            const cos = Math.cos(item.angle);
            const sin = Math.sin(item.angle);
            const localX = dx * cos + dy * sin;
            const localY = -dx * sin + dy * cos;
            let envelope = 0;

            if (item.shape === 'sphere') {
                const sphere = (dx * dx + dy * dy) / (spherePx * spherePx);
                envelope = Math.exp(-sphere * 1.9);
            } else if (item.shape === 'cube') {
                const cube = Math.max(Math.abs(localX), Math.abs(localY)) / cubePx;
                envelope = cube <= 1 ? (1 - cube * 0.35) : Math.exp(-(cube - 1) * 4.0) * 0.25;
            } else {
                const ellipsoid = (localX / longPx) ** 2 + (localY / shortPx) ** 2;
                envelope = Math.exp(-ellipsoid * 1.7);
            }

            envelope *= item.weight * item.visible;
            const phase = Math.cos(localX * 0.8 + localY * 0.2 + i * 0.13);
            value += envelope * (0.010 + smallK * 0.003) * phase - envelope * (smallN - 1) * 0.003;
        }

        return value;
    }

    public download() {
        if (this.backendResult && this.backendResult.pngDataUrl) {
            this.downloadDataUrl(this.backendResult.pngDataUrl, this.backendResult.pngFilename || `${this.baseFilename}.png`);
            return;
        }
        if (this.backendLoading) {
            alert('실제 HoloPy 계산이 아직 진행 중입니다. 완료 후 PNG를 저장해 주세요.');
            return;
        }
        if (this.backendError) {
            alert('실제 HoloPy 결과가 없어 PNG를 저장하지 않았습니다. 오류를 해결한 뒤 다시 실행해 주세요.');
            return;
        }

        this.derived = this.computeDerived();
        const canvas = document.createElement('canvas');
        this.drawToCanvas(canvas, true);

        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `${this.baseFilename}.png`;
        link.click();
    }

    public downloadExcel() {
        if (this.backendResult && this.backendResult.xlsxDataUrl) {
            this.downloadDataUrl(this.backendResult.xlsxDataUrl, this.backendResult.xlsxFilename || `${this.baseFilename}.xlsx`);
            return;
        }
        if (this.backendLoading) {
            alert('실제 HoloPy 계산이 아직 진행 중입니다. 완료 후 Excel을 저장해 주세요.');
            return;
        }
        if (this.backendError) {
            alert('실제 HoloPy 결과가 없어 Excel을 저장하지 않았습니다. 오류를 해결한 뒤 다시 실행해 주세요.');
            return;
        }

        this.derived = this.computeDerived();
        const shape = Math.round(this.clamp(this.num('detectorShape', 50), 16, 512));
        const values = this.makeHologram(shape, true);
        const rows: string[] = [
            '<?xml version="1.0"?>',
            '<?mso-application progid="Excel.Sheet"?>',
            '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns:html="http://www.w3.org/TR/REC-html40">',
            '<Worksheet ss:Name="hologram"><Table>'
        ];

        for (let y = 0; y < shape; y++) {
            const cells: string[] = [];
            for (let x = 0; x < shape; x++) {
                cells.push(`<Cell><Data ss:Type="Number">${this.excelNumber(values[y * shape + x])}</Data></Cell>`);
            }
            rows.push(`<Row>${cells.join('')}</Row>`);
        }

        rows.push('</Table></Worksheet></Workbook>');
        const blob = new Blob([rows.join('')], { type: 'application/vnd.ms-excel;charset=utf-8' });
        this.saveBlob(blob, `${this.baseFilename}.xls`);
    }

    public async downloadBatchZip(sourceResult: any = null) {
        let result = sourceResult || (this.isAnalysisMode ? this.activeAnalysisResult : this.backendResult) || this.backendResult || this.activeAnalysisResult;
        if (result && !result.zipDataUrl && result === this.activeAnalysisResult) {
            result = await this.hydrateSelectedAnalysisRecord('zip');
        }
        if (result && result.zipDataUrl) {
            this.downloadDataUrl(result.zipDataUrl, result.zipFilename || `${this.nkBatchBaseFilename}.zip`);
            return;
        }
        if (this.backendLoading) {
            alert('반복 실험 계산이 아직 진행 중입니다. 완료 후 ZIP을 저장해 주세요.');
            return;
        }
        alert('다운로드할 반복 실험 ZIP 결과가 없습니다.');
    }

    public async downloadAnalysisImage() {
        let result = this.activeAnalysisResult || this.backendResult;
        if (result && !result.pngDataUrl && result === this.activeAnalysisResult) {
            result = await this.hydrateSelectedAnalysisRecord('image');
        }
        if (result && result.pngDataUrl) {
            this.downloadDataUrl(result.pngDataUrl, result.pngFilename || `${result.filename || this.baseFilename}.png`);
            return;
        }
        alert('다운로드할 분석 이미지가 없습니다.');
    }

    public async downloadAnalysisIntensityExcel() {
        let result = this.activeAnalysisResult || this.backendResult;
        if (result && !result.xlsxDataUrl && result === this.activeAnalysisResult) {
            result = await this.hydrateSelectedAnalysisRecord('xlsx');
        }
        if (result && result.xlsxDataUrl) {
            this.downloadDataUrl(result.xlsxDataUrl, result.xlsxFilename || `${result.filename || this.baseFilename}.xlsx`);
            return;
        }
        alert('다운로드할 intensity Excel 결과가 없습니다.');
    }

    public async downloadShadowExcel() {
        let result = this.activeAnalysisResult || this.backendResult;
        if (result && !result.shadowXlsxDataUrl && result === this.activeAnalysisResult) {
            result = await this.hydrateSelectedAnalysisRecord('shadow');
        }
        if (result && result.shadowXlsxDataUrl) {
            this.downloadDataUrl(result.shadowXlsxDataUrl, result.shadowXlsxFilename || `${this.baseFilename}_shadow_parameters.xlsx`);
            return;
        }
        alert('다운로드할 Shadow parameter Excel 결과가 없습니다.');
    }

    public downloadAverageGraphSvg() {
        const values = this.shadowAverageProfile;
        if (values.length < 2 || !this.shadowAveragePolyline) {
            alert('저장할 평균 축 그래프가 없습니다. 새로 실행한 분석 결과를 선택해 주세요.');
            return;
        }

        const minValue = this.shadowAverageProfileMin;
        const maxValue = this.shadowAverageProfileMax;
        const meanValue = this.shadowAverageProfileMean;
        const svg = [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 420" width="720" height="420">',
            '<rect width="720" height="420" fill="#ffffff"/>',
            '<text x="48" y="42" fill="#111827" font-family="Arial, sans-serif" font-size="22" font-weight="700">Average intensity profile</text>',
            `<text x="48" y="68" fill="#6b7280" font-family="Arial, sans-serif" font-size="13">n=${values.length}, mean=${this.formatNumber(meanValue, 2)}, min=${this.formatNumber(minValue, 2)}, max=${this.formatNumber(maxValue, 2)}</text>`,
            '<line x1="48" y1="348" x2="680" y2="348" stroke="#d1d5db" stroke-width="2"/>',
            '<line x1="48" y1="92" x2="48" y2="348" stroke="#d1d5db" stroke-width="2"/>',
            '<line x1="48" y1="220" x2="680" y2="220" stroke="#eef2f7" stroke-width="1"/>',
            `<polyline points="${this.shadowAveragePolylineForBox(48, 92, 632, 256)}" fill="none" stroke="#4f46e5" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>`,
            `<text x="48" y="386" fill="#6b7280" font-family="Arial, sans-serif" font-size="13">0 px</text>`,
            `<text x="620" y="386" fill="#6b7280" font-family="Arial, sans-serif" font-size="13">${values.length - 1} px</text>`,
            `<text x="58" y="108" fill="#6b7280" font-family="Arial, sans-serif" font-size="13">${this.formatNumber(maxValue, 1)}</text>`,
            `<text x="58" y="342" fill="#6b7280" font-family="Arial, sans-serif" font-size="13">${this.formatNumber(minValue, 1)}</text>`,
            '</svg>',
        ].join('');
        this.saveBlob(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }), `${this.graphDownloadBaseName}_average_profile.svg`);
    }

    public downloadShadowRawCsv() {
        const average = this.shadowAverageProfile;
        const axisProfiles = this.shadowAxisProfiles;
        if (!average.length && !axisProfiles.length) {
            alert('저장할 raw profile 데이터가 없습니다. 새로 실행한 분석 결과를 선택해 주세요.');
            return;
        }

        const columns = [
            { key: 'pixel', values: [] as any[] },
            { key: 'Average', values: average },
            ...axisProfiles.map((axis: any) => ({
                key: `Axis_${axis.axis || ''}_${axis.degree || 0}deg`,
                values: (axis.values || []).map((value: any) => Number(value)),
            }))
        ];
        const rowCount = Math.max(...columns.map((column: any) => column.values.length), 0);
        const rows = [
            columns.map((column: any) => this.csvCell(column.key)).join(','),
        ];
        for (let index = 0; index < rowCount; index++) {
            rows.push(columns.map((column: any) => {
                if (column.key === 'pixel') return String(index);
                const value = column.values[index];
                return Number.isFinite(value) ? String(value) : '';
            }).join(','));
        }

        this.saveBlob(new Blob([rows.join('\r\n')], { type: 'text/csv;charset=utf-8' }), `${this.graphDownloadBaseName}_axis_profiles_raw.csv`);
    }

    public downloadNkFitProfileCsv() {
        const real = this.nkFitReferenceProfile;
        const simulated = this.nkFitBestProfile;
        if (!real.length && !simulated.length) {
            alert('저장할 NK fitting profile 데이터가 없습니다.');
            return;
        }
        const rowCount = Math.max(real.length, simulated.length);
        const rows = ['pixel,real_average_gray,best_simulated_gray'];
        for (let index = 0; index < rowCount; index++) {
            const realValue = real[index];
            const simValue = simulated[index];
            rows.push([
                index,
                Number.isFinite(realValue) ? realValue : '',
                Number.isFinite(simValue) ? simValue : '',
            ].join(','));
        }
        this.saveBlob(new Blob([rows.join('\r\n')], { type: 'text/csv;charset=utf-8' }), `${this.graphDownloadBaseName}_nk_fit_profile_comparison.csv`);
    }

    private shadowAveragePolylineForBox(left: number, top: number, width: number, height: number) {
        const values = this.shadowAverageProfile;
        if (values.length < 2) return '';
        const minValue = this.shadowAverageProfileMin;
        const maxValue = this.shadowAverageProfileMax;
        const span = Math.max(1e-9, maxValue - minValue);
        return values.map((value: number, index: number) => {
            const x = left + (index / Math.max(1, values.length - 1)) * width;
            const y = top + (1 - (value - minValue) / span) * height;
            return `${x.toFixed(2)},${y.toFixed(2)}`;
        }).join(' ');
    }

    private profilePolylineForBox(values: number[], left: number, top: number, width: number, height: number, minValue: number, maxValue: number) {
        if (!values || values.length < 2) return '';
        const span = Math.max(1e-9, maxValue - minValue);
        return values.map((value: number, index: number) => {
            const x = left + (index / Math.max(1, values.length - 1)) * width;
            const y = top + (1 - (value - minValue) / span) * height;
            return `${x.toFixed(2)},${y.toFixed(2)}`;
        }).join(' ');
    }

    private csvCell(value: any) {
        const text = String(value ?? '');
        if (/[",\r\n]/.test(text)) {
            return `"${text.replace(/"/g, '""')}"`;
        }
        return text;
    }

    private filenameValue(value: any, digits: number = 4) {
        const numeric = Number(value);
        let text = Number.isFinite(numeric)
            ? numeric.toFixed(digits)
            : String(value || '');
        if (text.includes('.')) text = text.replace(/\.?0+$/, '');
        if (text === '-0') text = '0';
        text = text.trim().replace(/-/g, 'm');
        text = text.replace(/[^A-Za-z0-9_.=-]+/g, '-').replace(/^-+|-+$/g, '');
        return text || '0';
    }

    private filenamePart(key: string, value: any, digits: number = 4) {
        return `${key}=${this.filenameValue(value, digits)}`;
    }

    private filenameRangePart(key: string, start: any, end: any, step: any, unit: string = '', digits: number = 4) {
        return `${key}=${this.filenameValue(start, digits)}-${this.filenameValue(end, digits)}${unit}_step=${this.filenameValue(step, digits)}${unit}`;
    }

    public num(key: string, fallback: number) {
        const value = Number(this.params[key]);
        return Number.isFinite(value) ? value : fallback;
    }

    private formatNumber(value: number, digits: number) {
        if (!Number.isFinite(value)) return '0';
        return value.toFixed(digits).replace(/\.?0+$/, '');
    }

    public progressValue(value: any, fallback: number = 0) {
        const numeric = Number(value);
        const next = Number.isFinite(numeric) ? numeric : fallback;
        return Math.round(this.clamp(next, 0, 100));
    }

    public phaseLabel(state: string) {
        if (state === 'queued' || state === 'starting') return '작업 준비 중';
        if (state === 'preparing') return '산란체 구성 중';
        if (state === 'calculating' || state === 'running') return 'HoloPy 계산 중';
        if (state === 'saving' || state === 'checking') return '결과 확인 중';
        if (state === 'completed') return '완료';
        if (state === 'cancelled') return '중단됨';
        return '진행 중';
    }

    private saveBlob(blob: Blob, filename: string) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 250);
    }

    private downloadDataUrl(dataUrl: string, filename: string) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    private scheduleBackendPoll(delayMs: number) {
        this.clearBackendPoll();
        this.backendPollTimer = window.setTimeout(() => {
            this.refreshHolopyStatus();
        }, delayMs);
    }

    private scheduleBackendStartRetry(delayMs: number) {
        this.clearBackendPoll();
        this.backendPollTimer = window.setTimeout(() => {
            this.startBackendJob();
        }, delayMs);
    }

    private clearBackendPoll() {
        if (this.backendPollTimer) {
            window.clearTimeout(this.backendPollTimer);
            this.backendPollTimer = null;
        }
    }

    private drawDataUrlToCanvas(dataUrl: string) {
        return new Promise<void>((resolve, reject) => {
            if (!this.previewCanvas) {
                resolve();
                return;
            }

            const canvas = this.previewCanvas.nativeElement;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                resolve();
                return;
            }

            const img = new Image();
            img.onload = () => {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0);
                this.imageReady = true;
                resolve();
            };
            img.onerror = () => reject(new Error('HoloPy 결과 이미지를 표시하지 못했습니다.'));
            img.src = dataUrl;
        });
    }

    private excelNumber(value: number) {
        if (!Number.isFinite(value)) return '0';
        return value.toPrecision(10);
    }

    private clamp(value: number, min: number, max: number) {
        return Math.min(max, Math.max(min, value));
    }

    private random(seed: number, index: number, salt: number) {
        const value = Math.sin(seed * 12.9898 + index * 78.233 + salt * 37.719) * 43758.5453;
        return value - Math.floor(value);
    }
}

export default PageHolopyComponent;